import find from "lodash/find";
import { deepClone } from "./copyObject";
import moment from "moment";
import findIndex from "lodash/findIndex";
import orderBy from "lodash/orderBy";
import filter from "lodash/filter";
import parse from "react-html-parser";
import groupAchievement from "../assets/stories/grp_ach.svg";
import careerGrowth from "../assets/stories/c_growth.svg";
import other from "../assets/stories/other.svg";
import collab from "../assets/stories/collab.svg";
import microactions from "../assets/stories/microactions.svg";
import feedback from "../assets/stories/feedback.svg";
import question from "../assets/stories/question.svg";
import resource from "../assets/stories/resource.svg";
import ideaSuggestion from "../assets/stories/idea_suggestion.svg";
import sustainabilityImg from "../assets/stories/sustainability1.png";
import workplaceCult from "../assets/stories/workplace_cult.svg";
import celebrate from "../assets/stories/celebrate.svg";
import curious from "../assets/stories/curious.svg";
import like from "../assets/stories/like.svg";
import support from "../assets/stories/support.svg";
import action from "../assets/stories/action.svg";
import thank from "../assets/stories/thank.svg";
import sad from "../assets/stories/sad.svg";
import { getFlatDataFromTree } from "react-sortable-tree";
import OOLogo from "../assets/OOLogo.svg";
import _clone from "lodash/clone";
import _escapeRegExp from "lodash/escapeRegExp";
import eventInvite from "../assets/events/invite.svg";

import libphonenumber from "google-libphonenumber"

// import officeFileIcon from '../assets/officeIcons/file-earmark.svg'
// import officeWordIcon from '../assets/officeIcons/file-word.svg'
// import officePptIcon from '../assets/officeIcons/file-ppt.svg'
// import officePdfIcon from '../assets/officeIcons/file-pdf.svg'
// import officeExcelIcon from '../assets/officeIcons/file-excel.svg'

import officeFileIcon from "../assets/officeIcons/file-earmark.svg";
import officeWordIcon from "../assets/officeIcons/i_doc.png";
import officePptIcon from "../assets/officeIcons/i_ppt.png";
import officePdfIcon from "../assets/officeIcons/i_pdf.png";
import officeExcelIcon from "../assets/officeIcons/i_excel.png";
import { isEmpty, sortBy } from "lodash";
import BenchMarkDetailsModal from "../pages/dani/BenchMarkDetailsModal";

var Filter = require("bad-words");

// https://icons.getbootstrap.com/
// https://prod-oo.s3.us-east-2.amazonaws.com/undraw_remotely_2j6y.svg

export const loginImg =
  "https://prod-oo.s3.us-east-2.amazonaws.com/undraw_remotely_2j6y.svg";

export const loginImgTrivvy =
  "/trivvy-people.png";

// "https://prod-oo.s3.us-east-2.amazonaws.com/ouroffice-login-page-image"
// "https://prod-oo.s3.us-east-2.amazonaws.com/undraw_remotely_2j6y.svg"
export const oktaImg =
  "https://prod-oo.s3.us-east-2.amazonaws.com/okta_sso.png";
export const oktaLogo =
  "https://prod-oo.s3.us-east-2.amazonaws.com/okta-icon.svg";

const hostname = window.location.hostname;
let localBool = hostname.indexOf("localhost") > -1;
let devBool = hostname.indexOf("devportal") > -1;
let qaBool = hostname.indexOf("qaportal") > -1;

let aws_s3_bucket;

// AWS_S3_BUCKET: 'dev-oo-app-api', //Dev s3 bucket for attachments
// QA ---  AWS_S3_BUCKET: 'qa-oo-app-attachment', // Qa s3 bucket for attachments
// PROD --- AWS_S3_BUCKET: 'prod-oo-app-attachment', // Production s3 bucket for attachments

if (localBool || devBool) {
  aws_s3_bucket = "dev-oo-app-api";
} else if (qaBool) {
  aws_s3_bucket = "qa-oo-app-attachment";
} else {
  aws_s3_bucket = "prod-oo-app-attachment";
}

export const CANVAS_PROXY_IMAGE_URL = `https://${aws_s3_bucket}.s3.us-east-2.amazonaws.com`;

export const url_location =
  window.location.href && window.location.href.length > 0
    ? window.location.href
    : window.location.host;

// console.log("url_location --- ", url_location);


export const isTrivvyUrl = (org = null) => {
  const url_location =
    window.location.href && window.location.href.length > 0
      ? window.location.href
      : window.location.host;

  if (
    url_location.indexOf("trivvy.ouroffice") > -1 ||
    url_location.indexOf("qaportal.ouroffice") > -1 ||
    url_location.indexOf("localhost") > -1 ||
    url_location.indexOf("trivia") > -1 ||
    url_location.indexOf("my-trivvys") > -1 ||
    url_location.indexOf("pending-trivvys") > -1 ||
    url_location.indexOf("my-surveys") > -1 ||
    url_location.indexOf("my-knowledge-checks") > -1 ||
    url_location.indexOf("enterprise-info") > -1 
    // || (org && org.isSignedUpFromTrivvyWebsite)
  ) {
    // console.log('url_location --- ', url_location)

    // if(url_location.indexOf('trivvy.ouroffice')>-1  ){
    return true;
  }

  return false;
};

export const isTrivvyProduct = () => {
  const url_location =
    window.location.href && window.location.href.length > 0
      ? window.location.href
      : window.location.host;

  console.log({url_location})

  if (
    url_location.indexOf("trivvy.ouroffice") > -1 ||
    // url_location.indexOf("qaportal.ouroffice") > -1 ||
    // url_location.indexOf("localhost") > -1 ||
    url_location.indexOf("trivia") > -1 ||
    url_location.indexOf("my-trivvys") > -1 ||
    url_location.indexOf("pending-trivvys") > -1   ||
    url_location.indexOf("my-surveys") > -1 ||
    url_location.indexOf("my-knowledge-checks") > -1
  ) {
    // if(url_location.indexOf('trivvy.ouroffice')>-1  ){
    return true;
  }

  return false;
};

export const placeholder_text = {
  action_create: "Write your action out here.",
};

export const getTrivvyPlanName = (val) => {
  if (val == null || val == undefined || val === "001") {
    return "Basic";
  } else if (val === "002") {
    return "Plus";
  } else if (val === "003") {
    return "Premium";
  } else {
    return "Enterprise";
  }
};
// export const grpBannerImg = "https://prod-oo.s3.us-east-2.amazonaws.com/grpBanner.png" ---> facebooks

export const eventBannerImg =
  "https://prod-oo.s3.us-east-2.amazonaws.com/event_bannerImg.jpg";

export const grpBannerImg =
  "https://prod-oo.s3.us-east-2.amazonaws.com/grpBannerImg_diverse.jpg";
export const grpBannerImg_00 =
  "https://prod-oo.s3.us-east-2.amazonaws.com/grpBannerImg_alt4.jpg";
export const grpBannerImg_01 =
  "https://prod-oo.s3.us-east-2.amazonaws.com/event_img_alt3.jpg";

export const grpBannerImg_original =
  "https://prod-oo.s3.us-east-2.amazonaws.com/event_img.jpg";

export const grpBannerImgAlt1 =
  "https://prod-oo.s3.us-east-2.amazonaws.com/event_img_alt.jpg";

export const grpEventImg =
  "https://prod-oo.s3.us-east-2.amazonaws.com/event_img_alt2.jpg";

export const Spinner = "https://prod-oo.s3.us-east-2.amazonaws.com/spinner.gif";

const environment_type =
  hostname.indexOf("localhost") > -1
    ? "local"
    : hostname.indexOf("devportal") > -1
    ? "dev"
    : hostname.indexOf("qaportal") > -1
    ? "qa"
    : "prod";

// n check, 2) title, 3) due date, 4) priority + ability to add more columns – Now

export const action_table_columns_min = ["dueDate", "progress", "priority"];

export const action_table_columns = [
  "assignee",
  "project",
  "dueDate",
  "progress",
  "status",
  "priority",
  "taskCounter",
  "privacyStatus",
  "createdBy",
  "type"
];

export const get_utc_offset = () => {
  let offset = new Date().getTimezoneOffset();
  if (offset <= 0) {
    // if timezone is in UK or after that
    return true;
  }
  return true;
};

//  export const action_table_columns_width= {
// actionTitle : {nm: 3,m:5},
// assignee : {nm: 1,m:2},
// project : {nm: 2,m:3},
// dueDate : {nm: 2,m:2},
// progress : {nm: 2,m:2},
// status : {nm: 1,m:2},
// priority : {nm: 1,m:1}
//  }

export const table_column_names = {
  planning: {
    type: "planning",
    1: "personal",
    2: "enterprise",
  },
};

export const baseUrl = () => {
  const hostname = window.location.hostname;
  let localBool = hostname.indexOf("localhost") > -1;
  let devBool = hostname.indexOf("devportal") > -1;
  let qaBool = hostname.indexOf("qaportal") > -1;
  let portalBool = hostname.indexOf("portal.o") > -1;

  let baseUrl;

  if (localBool) {
    baseUrl = "http://localhost:3000/";
  } else if (devBool) {
    baseUrl = "https://devportal.ouroffice.io/";
  } else if (qaBool) {
    baseUrl = "https://qaportal.ouroffice.io/";
  } else if (portalBool) {
    baseUrl = "https://portal.ouroffice.io/";
  }

  var result = window.location.protocol + "//" + window.location.host + "/";

  return result;
};

export const action_table_columns_width = (cols, name, isMobile) => {
  // console.log(cols, name, isMobile);
  const col_length = cols.length + 1;
  const colsIncludesProject = !isEmpty(cols.find((x) => x === "project"));

  const computeValue = (base) => {
    if (!colsIncludesProject) {
      if (col_length <= 4) {
        return base + 0.4;
      } else if (col_length === 5) {
        return base + 0.3;
      } else if (col_length === 6) {
        return base + 0.25;
      } else if (col_length >= 7) {
        return base + 0.2;
      }
    } else {
      return base;
    }
  };

  if (col_length <= 4) {
    let obj = {
      actionTitle: { nm: 3, m: 2 },
      assignee: { nm: computeValue(1.75), m: 1 },
      project: { nm: 3.5, m: 2 },
      dueDate: { nm: computeValue(1.75), m: 1 },
      progress: { nm: computeValue(1.75), m: 1 },
      status: { nm: computeValue(1.75), m: 1 },
      priority: { nm: computeValue(1.75), m: 1 },
      taskCounter: { nm: computeValue(1.75), m: 1 },
      createdBy: { nm: computeValue(1.75), m: 1 },
      privacyStatus: { nm: computeValue(1.75), m: 1 },
      type: { nm: computeValue(1.75), m: 1 },
    };

    return obj[name][isMobile];
  } else if (col_length == 5) {
    let obj = {
      actionTitle: { nm: 3, m: 2 },
      assignee: { nm: computeValue(1.5), m: 1 },
      project: { nm: 3, m: 2 },
      dueDate: { nm: computeValue(1.5), m: 1 },
      progress: { nm: computeValue(1.5), m: 1 },
      status: { nm: computeValue(1.5), m: 1 },
      priority: { nm: computeValue(1.5), m: 1 },
      taskCounter: { nm: computeValue(1.5), m: 1 },
      createdBy: { nm: computeValue(1.5), m: 1 },
      privacyStatus: { nm: computeValue(1.5), m: 1 },
      type: { nm: computeValue(1.5), m: 1 },
    };
    return obj[name][isMobile];
  } else if (col_length == 6) {
    let obj = {
      actionTitle: { nm: 2.5, m: 2 },
      assignee: { nm: computeValue(1.25), m: 1 },
      project: { nm: 2.5, m: 2 },
      dueDate: { nm: computeValue(1.25), m: 1 },
      progress: { nm: computeValue(1.25), m: 1 },
      status: { nm: computeValue(1.25), m: 1 },
      priority: { nm: computeValue(1.25), m: 1 },
      taskCounter: { nm: computeValue(1.25), m: 1 },
      createdBy: { nm: computeValue(1.25), m: 1 },
      privacyStatus: { nm: computeValue(1.25), m: 1 },
      type: { nm: computeValue(1.25), m: 1 },
    };

    return obj[name][isMobile];
  } else if (col_length >= 7) {
    let obj = {
      actionTitle: { nm: 2, m: 2 },
      assignee: { nm: computeValue(1), m: 1 },
      project: { nm: 2, m: 2 },
      dueDate: { nm: computeValue(1), m: 1 },
      progress: { nm: computeValue(1), m: 1 },
      status: { nm: computeValue(1), m: 1 },
      priority: { nm: computeValue(1), m: 1 },
      taskCounter: { nm: computeValue(1), m: 1 },
      createdBy: { nm: computeValue(1), m: 1 },
      privacyStatus: { nm: computeValue(1), m: 1 },
      type: { nm: computeValue(1), m: 1 },
    };

    if(!obj[name]){
      return 0;
    }
    return obj[name][isMobile];
  }
};

export const action_table_column_name_display = (col) => {
  console.log("col --- ", col);
  let obj = {
    assignee: "Assignee",
    project: "Objective",
    dueDate: "Due Date",
    progress: "Progress",
    status: "Status",
    priority: "Priority",
    taskCounter: "Sub-Actions",
    createdBy: "Created By",
    privacyStatus: "Privacy",
  };
  return obj[col];
};

export const chart_legend_position = (kpi_count) => {
  if (kpi_count > 3) {
    return -0.28;
  } else if (kpi_count <= 3 && kpi_count > 1) {
    return -0.22;
  } else if (kpi_count == 1) {
    return -0.18;
  }
};

export const chartParams = (chart, param, val) => {
  // console.log("kpiData ---- ", chart);
  console.log('params --- ', param)
  let selectorOptions = {
    buttons: [
      {
        step: "month",
        stepmode: "backward",
        count: 3,
        label: "last 3m",
      },
      {
        step: "month",
        stepmode: "backward",
        count: 6,
        label: "6m",
      },
      {
        step: "year",
        stepmode: "backward",
        count: 1,
        label: "1y",
      },
      {
        step: "all",
      },
    ],
  };



  // let plotParams= {
  //     margin:{ l: 35,
  //         r: 5,
  //         b: 5,
  //         t: 35,
  //         pad:0,
  //     },
  //     paper_bgcolor: "white",
  //     plot_bgcolor: "#e5ecf694",
  //     legend: {
  //         bgcolor:'white',
  //         xref:'container',
  //         yref:'container',
  //         yanchor:'top',
  //         xanchor: "left",
  //         // y:-0.4, // good for 3 kpis or greater
  //         // y:-0.3,
  //         y:chart_legend_position(chart.kpiData.length),
  //         x:0,
  //         orientation: "h",
  //         // y:0.9,
  //         // x:0.9,
  //         // entrywidthmode:'pixels',
  //         // entrywidth:20,
  //         //  y:chart.kpiData.length>3? -5.5 :-1.7,
  //         // x:chart.kpiData.length>3? -2:-0.05
  //         // y: -1.7,
  //         // x:-0.05
  //         // x:0,
  //         // y:-4,
  //       },
  //       xaxis: {
  //         showgrid: true,
  //         type: "date",
  //         automargin: true,
  //         // title: {
  //         //   text:
  //         //     moment(chart.xMinDate).format("YYYY") ===
  //         //     moment(chart.xMaxDate).format("YYYY")
  //         //       ? `Date (${moment(chart.xMinDate).format("YYYY")})`
  //         //       : "Date",
  //         //   standoff: 10,
  //         // },
  //         dtick: chart.plotlyDTick,
  //         tickformat:
  //           typeof chart.plotlyDTick != "number" ? "%b<br>%Y" : "%b %e<br>%Y",
  //         tick0: chart.xMinDate,
  //         zerolinecolor: "#ffffff",
  //         zerolinewidth: 1.2,
  //         gridcolor: "#ffffff",
  //         gridwidth: 1.2,
  //         rangeselector: chart.selectorOptions,
  //         // range: [
  //         //   new Date(chart.xMinDate).getTime(),
  //         //   new Date(chart.xMaxDate).getTime()
  //         // ] ,
  //         tickfont: { color: "#313236" },
  //       },
  //       yaxis: {
  //         showgrid: true,
  //         zerolinecolor: "#ffffff",
  //         zerolinewidth: 1,

  //         gridcolor: "#ffffff",
  //         gridwidth: 1.2,

  //         tickformat:
  //           chart.yAxisFormat && chart.yAxisFormat == "Absolute"
  //             ? undefined
  //             : "%",
  //         // .3%', '.0%',
  //         tickfont: { color: "#313236" },
  //         // title: {
  //         //   text:
  //         //     chart.yAxisFormat && chart.yAxisFormat == "Absolute"
  //         //       ? `Absolute`
  //         //       : "Percent",
  //         //   standoff: 10,
  //         // },
  //         // title:{standoff:20},
  //         range: chart.yRange,
  //         ticklabelposition:'outside left',
  //         scrollZoom: true,
  //         // rangemode: 'tozero',
  //         // fixedrange:true,
  //         automargin: true,
  //       },
  //       config:{
  //         // displayModeBar:true,
  //         scrollZoom: true,
  //         // editable:isSafari?false:true,
  //         modeBarButtonsToAdd: [
  //           "drawline",
  //           "drawopenpath",
  //           "drawclosedpath",
  //           "drawcircle",
  //           "drawrect",
  //           "eraseshape",
  //         ],
  //         displaylogo: false,
  //         // staticPlot:(plotlyData && plotlyData.length>0)?false:true,
  //         responsive: true,
  //         toImageButtonOptions: {
  //           format: "png", // one of png, svg, jpeg, webp
  //           // moment(d.createdDate).format('MM/DD/YYYY')
  //           filename: `${chart.name} in office ${chart.officeName} - ${moment(
  //             new Date()
  //           ).format("MM-D-YYYY")}`,
  //           height: 600,
  //           width: null,
  //           scale: 1, // Multiply title/legend/axis/canvas sizes by this factor
  //         },
  //       }
  // }

  let selectorOptionBottom ={
    buttons: [
      {
        step: "month",
        stepmode: "backward",
        count: 3,
        label: "last 3m",
      },
      {
        step: "month",
        stepmode: "backward",
        count: 6,
        label: "6m",
      },
      {
        step: "year",
        stepmode: "backward",
        count: 1,
        label: "1y",
      },
      {
        step: "all",
      },
    ],
    //  y: 0,
    // yanchor: 'bottom'
  }
  switch (param) {
    case "legend":
      return {
        bgcolor: "white",
        xref: "container",
        yref: "container",
        yanchor: "top",
        xanchor: "left",
        // y:-0.4, // good for 3 kpis or greater
        // y:-0.3,
        y: chart_legend_position(chart.kpiData.length),
        x: 0,
        orientation: "h",
        // y:0.9,
        // x:0.9,
        // entrywidthmode:'pixels',
        // entrywidth:20,
        //  y:chart.kpiData.length>3? -5.5 :-1.7,
        // x:chart.kpiData.length>3? -2:-0.05
        // y: -1.7,
        // x:-0.05
        // x:0,
        // y:-4,
      };
    case "margin":
      return {
        l: 10,
        r: 10,
        b: 0,
        t: 5,
        pad: 0,
      };
    case "xaxis":
      return {
        showgrid: true,
        // modebar:{orientation:'v'},
        type: "date",
        automargin: true,
        ticks: "outside",
        ticklabelposition: "outside bottom",
        dtick: chart.plotlyDTick,
        tickformat:
          typeof chart.plotlyDTick != "number" ? "%b<br>%Y" : "%b %e<br>%Y",
        tick0: chart.xMinDate,
        zerolinecolor: "#ffffff",
        zerolinewidth: 1.2,
        gridcolor: "#ffffff",
        gridwidth: 1.2,
        margin: {
          pad: 20
        },
        rangeselector: val == 'rangeB'?selectorOptionBottom: selectorOptions,
        tickfont: { color: "#313236" },
      };
    case 'rangeB':
      return {
        showgrid: true,
        // modebar:{orientation:'v'},
        type: "date",
        automargin: true,
        ticks: "outside",
        ticklabelposition: "outside bottom",
        dtick: chart.plotlyDTick,
        tickformat:
          typeof chart.plotlyDTick != "number" ? "%b<br>%Y" : "%b %e<br>%Y",
        tick0: chart.xMinDate,
        zerolinecolor: "#ffffff",
        zerolinewidth: 1.2,
        gridcolor: "#ffffff",
        gridwidth: 1.2,
        margin: {
          pad: 10
        },
        tickfont: { color: "#313236" },
        rangeselector:selectorOptionBottom
      }
    case "yaxis":
      return {
        showgrid: true,
        zerolinecolor: "#ffffff",
        zerolinewidth: 1,

        gridcolor: "#ffffff",
        gridwidth: 1.2,

        tickformat:
          chart.yAxisFormat && chart.yAxisFormat == "Absolute"
            ? undefined
            : "%",
        // .3%', '.0%',
        tickfont: { color: "#313236" },
        // title: {
        //   text:
        //     chart.yAxisFormat && chart.yAxisFormat == "Absolute"
        //       ? `Absolute`
        //       : "Percent",
        //   standoff: 10,
        // },
        // title:{standoff:20},
        range: chart.yRange,
        ticklabelposition: "outside left",
        scrollZoom: true,
        // rangemode: 'tozero',
        // fixedrange:true,
        automargin: true,
      };
    case "config":
      return {
        // displayModeBar:true,
        scrollZoom: true,
        // editable:isSafari?false:true,
        modeBarButtonsToAdd: val=='rangeB'?[]:[
          "drawline",
          "drawopenpath",
          "drawclosedpath",
          "drawcircle",
          "drawrect",
          "eraseshape",
        ],
        displaylogo: false,
        doubleClick: false,
        // staticPlot:(plotlyData && plotlyData.length>0)?false:true,
        responsive: true,
        toImageButtonOptions: {
          format: "png", // one of png, svg, jpeg, webp
          // moment(d.createdDate).format('MM/DD/YYYY')
          filename: chart.name
            ? `${chart.name} ${
                chart.officeName ? ` in office ${chart.officeName}` : ""
              } - ${moment(new Date()).format("MM-D-YYYY")}`
            : `Chart Preview - ${moment(new Date()).format("MM-D-YYYY")}`,
          height: 600,
          width: null,
          scale: 1, // Multiply title/legend/axis/canvas sizes by this factor
        },
      };
    default:
      return chart;
  }
};

export const trim_str = (str) => {
  return str.replace(/^\s+|\s+$/g, "");
};

export const getHtml2Text = (html) => {
  // return html.item(0).innerText.replace(/(&lt;([^>]+)>)/gi, "").replace(/\n/g, " ")
  return html.replace(/(<([^>]+)>)/gi, "").replace(/\t|\n|&nbsp;/gi, " ");
};

export const validate_val = (val) => {
  if (val == "" || val == undefined || val == null || !val) {
    return true;
  }
  return false;
};

export const dynamic_urls = (user, organization) => {
  let orgId =
    organization && organization._id ? organization._id : organization;
  let userId = user._id ? user._id : user;
  return {
    my_profile: `/home/${orgId}/profile/${userId}`,
    my_profile1: `/home/profile`,
    my_events: `/home/${orgId}/profile/${userId}/events`,
    my_events1: `/home/profile/events`,
    trivvy_dev: `/home/trivia/${orgId}/list`,
  };
};

export const giphyAPIKey = "WizeCPDbCTQsPNK5OdxnfV0zbqn7wb5z";

let day = 86400000;
// "#e0f3f8",
// #fee090
// blind color palettes
// https://davidmathlogic.com/colorblind/#%231A85FF-%23D41159

let color_palette = [
  "rgb(0,107,164)",
  "rgb(255,128,14)",
  "rgb(171,171,171)",
  "rgb(89,89,89)",
  "rgb(95,158,209)",
  "rgb(200,82,0)",
  "rgb(137,137,137)",
  "rgb(162,200,236)",
  "rgb(255,188,121)",
  "rgb(207,207,207)",
];
// ["#ffd700",
// "#ffb14e",
// "#fa8775",
// "#ea5f94",
// "#cd34b5",
// "#9d02d7",
// "#0000ff",
// "#000000"]

// ["#a6003e", "#069668", "#88075f", "#368098", "#1b511d", "#f90da0", "#4e3b7e", "#887daf", "#682dbd", "#798a58", "#cb2c09", "#2580fe"]
// ["#e9648a", "#83cc3f", "#6633b4", "#a8dfd4", "#0b5313", "#16d0ae", "#8a0458", "#a0a3fd", "#2c457d", "#00d618", "#ee80fe"]
// ["#313695","#a50026","#4575b4","#d73027","#74add1","#f46d43","#abd9e9","#fdae61","#595959","#9a68f9","#ffffbf"]

export const ooStandardColor = "#F06292";
export const trivvyStandardColor = "#FF4500";

export const whiteLabelStyling = (attr, org, bool, isAddOpacity) => {
  if (
    org &&
    org != null &&
    org.whiteLabel &&
    org.whiteLabel.brandColor &&
    bool != true
  ) {
    let color = org.whiteLabel.brandColor;
    console.log(attr,'--- color --- ', color)

    if (attr.length == 1) {
      if (attr[0] == "borderTopColor" || isAddOpacity) {
        return { [attr[0]]: hexToRGBA(color, 0.5) };
      } else {
        return { [attr[0]]: color };
      }
    } else {
      return attr.reduce(
        (a, v) => ({
          ...a,
          [v]: v == "backgroundColor" ? hexToRGBA(color, 0.1) : color,
        }),
        {}
      );
    }
  }
};

export const is_event_past = (event) => {
  if (event) {
    let endDate = moment(event.endDate);
    if (endDate.isAfter(moment(new Date()))) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const plotlyPercentFormat = ",.0%";

export const return_sso_url = (type) => {
  if (type == "okta") {
    return okta_urls[environment_type];
  }
};

export const get_placehoder = (field, type) => {
  if (!field || field == undefined || field == null) {
    return type;
  } else {
    return field;
  }
};

export const create_user_edit_obj = (stateObj) => {
  let { updatedFields } = stateObj;
  let formData = new FormData();

  let payload = updatedFields.reduce(function(res, item) {
    res[item] = stateObj[item];
    if (item == "description") {
      res["sanitized_description"] = stateObj[
        "sanitized_description"
      ].replaceAll("\\n", "");
    }
    return res;
  }, {});

  for (const property in payload) {
    formData.append(`${property}`, payload[property]);
  }

  return { payload, formData };
};

export const matchUrl = (text) => {
  var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g || [];
  return text.match(urlRegex);
};

export const createUrlLink = (text) => {
  var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
  return text.replace(urlRegex, function(url, b, c) {
    var url2 = c == "www." ? "http://" + url : url;
    return '<a href="' + url2 + '" target="_blank">' + url + "</a>";
  });
};

export const createMentionUrl = (text, user) => {
  let displayText = _clone(text);
  const tags = displayText.match(/@\{\{[^\}]+\}\}/gi) || [];
  tags.map((myTag) => {
    const tagData = myTag.slice(3, -2);
    const tagDataArray = tagData.split("||");
    const tagDisplayValue = tagDataArray[1];
    const tagName = tagDataArray[2];
    displayText = displayText.replace(
      new RegExp(_escapeRegExp(myTag), "gi"),
      // tagDisplayValue
      `<a class="userMentionWord" href="/home/${user.organizationId._id}/profile/${tagDisplayValue}">@${tagName}</a>`
    );
  });
  return displayText;
};

// https://icons.getbootstrap.com/

const okta_urls = {
  // okta:'https://dev-36793732.okta.com/home/dev-36793732_ourofficedev_1/0oa5q5n4q36GVYJ385d7/aln5q5qtc9cHLP0gg5d7'
  // okta: 'https://dev-29279163.okta.com/app/dev-29279163_ouroffice_1/exk5lvk6nkdoG6tbP5d7/sso/saml'
  local:
    "https://dev-81576919.okta.com/home/dev-81576919_ourofficelocalhost_1/0oa5rzfpnhp8g543J5d7/aln5rzkmafeAkYsgX5d7",
  dev:
    "https://dev-81576919.okta.com/home/dev-81576919_ourofficedev_1/0oa5rym3slaUzx6bc5d7/aln5ryr7c7vps0rhi5d7",
  qa:
    "https://dev-81576919.okta.com/home/dev-81576919_ourofficeqa_1/0oa5ryot6sYyAZVEH5d7/aln5ryt0xnEULVbJd5d7",
  prod:
    "https://dev-81576919.okta.com/home/dev-81576919_ouroffice_1/0oa5rynzrvtCmEQ8K5d7/aln5ryulatWVTz5oD5d7",
};

export const skills_levels = [
  {
    id: 1,
    name: "Novice",
    description:
      "None to minimal use of the competency and is currently developing it",
  },
  {
    id: 2,
    name: "Intermediate",
    description:
      "Limited use of a competency and requires additional training to apply without assistance or frequent supervision",
  },
  {
    id: 3,
    name: "Competent",
    description:
      "Working or functional proficiency level which enables the competency to be exercised effectively",
  },
  {
    id: 4,
    name: "Proficient",
    description:
      "In depth proficiency level ; is able to assist, consult or lead others in the application of a competency",
  },
  {
    id: 5,
    name: "Expert",
    description:
      "Broad, in-depth proficiency; is recognized as an authority or master performer in exercising the competency",
  },
];

export const hard_skills_list = [
  {
    name: "Communications",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "co_347",
  },
  {
    name: "Global & Cultural Effectiveness",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "gl_744",
  },
  {
    name: "Data and Analytics",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "da_433",
  },
  {
    name: "Marketing / Storytelling",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "ma_1333",
  },
  {
    name: "Social Media",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "so_1947",
  },
  {
    name: "Digital Marketing",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "di_441",
  },
  {
    name: "Change Management",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "ch_340",
  },
  {
    name: "Process design / Reengineering",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "pr_1650",
  },
  {
    name: "Technology",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "te_2037",
  },
  {
    name: "Project Management",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "pr_1650",
  },
  {
    name: "Event Planning",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "ev_554",
  },
  {
    name: "Strategic Planning",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "st_1952",
  },
  {
    name: "Coding/Programming",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "co_347",
  },
  {
    name:
      "Financial Acumen, Account reconciliation, preparing budgets, Lean Portfolio Management,",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "fi_641",
  },
  {
    name: "Market research",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "ma_1333",
  },
  {
    name: "Product Development / Design",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "pr_1650",
  },
  {
    name: "Organizational design",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "or_1550",
  },
  {
    name: "Technical Writing",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "te_2037",
  },
  {
    name: "Cybersecurity",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "cy_357",
  },
  {
    name: "Video creation",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "vi_2241",
  },
  {
    name: "Quantitative research",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "qu_1753",
  },
  {
    name: "QA",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "qa_171",
  },
  {
    name: "Sales",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "sa_1933",
  },
  {
    name: "Human Resources",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "hu_853",
  },
  {
    name: "Financial Management",
    type: "hs_01",
    experience: 1,
    interest: false,
    code: "fi_641",
  },
];

export const soft_skills_list = [
  {
    name: "Problem solving",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "pr_4850",
  },
  {
    name: "Management abilities",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "ma_4533",
  },
  {
    name: "Relationship Building/Stakeholder Engagement",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "re_1837",
  },
  {
    name: "Collaboration",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "co_347",
  },
  {
    name: "Active Listening",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "ac_135",
  },
  {
    name: "Creative thinking",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "cr_3550",
  },
  {
    name: "Critical thinking",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "cr_3550",
  },
  {
    name: "Decision making",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "de_3637",
  },
  {
    name: "Planning and organizing",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "pl_4844",
  },
  {
    name: "Leadership",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "le_1237",
  },
  {
    name: "Detail oriented",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "dt_3352",
  },
  {
    name: "Emotional intelligence (EI)",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "em_3745",
  },
  {
    name: "Adaptability",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "ad_136",
  },
  {
    name: "Empathy",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "em_545",
  },
  {
    name: "rk ethic",
    type: "ss_01",
    experience: 1,
    interest: false,
    code: "wo_5547",
  },
];

export const groupERGcategories = [
  {
    id: 1,
    name: "Culture, Race and ethnicity",
    category: "ERG",
    color: color_palette[7],
  },
  { id: 2, name: "Disabilities", category: "ERG", color: color_palette[7] },
  { id: 4, name: "Women", category: "ERG", color: color_palette[7] },
  {
    id: 5,
    name: "Religion or faith-based",
    category: "ERG",
    color: color_palette[7],
  },
  { id: 6, name: "Gender", category: "ERG", color: color_palette[7] },
  {
    id: 7,
    name: "Sexual orientation",
    category: "ERG",
    color: color_palette[7],
  },
  { id: 8, name: "Age", category: "ERG", color: color_palette[70] },
  {
    id: 9,
    name: "Working parents, single parents and caregivers",
    category: "ERG",
    color: color_palette[7],
  },
  { id: 10, name: "Affinity group", category: "ERG", color: color_palette[7] },
  {
    id: 11,
    name: "Professional Development",
    category: "ERG",
    color: color_palette[7],
  },
  { id: 12, name: "Volunteer", category: "ERG", color: color_palette[7] },
];

export const parseCookie = (str) =>
  str
    .split(";")
    .map((v) => v.split("="))
    .reduce((acc, v) => {
      acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
      return acc;
    }, {});

 const checkValidation = (org, module) => {
  let { selectModule } = org;
  if (selectModule) {
    if (module && module.status) {
      if (
        module &&
        (module.isDisplayed || !module.hasOwnProperty("isDisplayed"))
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    if (
      module &&
      (module.isDisplayed || !module.hasOwnProperty("isDisplayed"))
    ) {
      return true;
    } else {
      return false;
    }
  }
};

export const checkValidationOfModule = (org, module) => {
  let { selectModule } = org;
  if (selectModule) {
    if (module && module.status) {
      if (
        module &&
        (module.isDisplayed || !module.hasOwnProperty("isDisplayed"))
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    if (
      module &&
      (module.isDisplayed || !module.hasOwnProperty("isDisplayed"))
    ) {
      return true;
    } else {
      return false;
    }
  }
};

export const navigate_user_to_module = (org, isHome, isOrgAdmin) => {
  let url;
  // console.log("testing!");
  if (isTrivvyUrl(org)) {
    url = `/home/trivia/${org._id}/list`;
  }
  if (
    checkValidation(org, org.isAnalytics) &&
    !org.isSetupSkipped &&
    !isOrgAdmin
  ) {
    if (checkValidation(org, org.isCultureApp)) {
      url = isHome ? "/stories" : "/home/stories";
    } else if (checkValidation(org, org.isPlanning)) {
      url = isHome ? "/my-activity" : "/home/my-activity";
    } else if (checkValidation(org, org.isToolkit)) {
      url = isHome ? "/toolkit/all" : "/home/toolkit/all";
    } else if (checkValidation(org, org.isGroups)) {
      url = isHome ? "/groups" : "/groups";
    }
  } else {
    if (checkValidation(org, org.isCultureApp)) {
      url = isHome ? "/stories" : "/home/stories";
    } else if (checkValidation(org, org.isAnalytics) && !org.isSetupSkipped) {
      url = isHome ? "/analytics/all" : "/home/analytics/all";
    } else if (checkValidation(org, org.isPlanning)) {
      url = isHome ? "/my-activity" : "/home/my-activity";
    } else if (checkValidation(org, org.isToolkit)) {
      url = isHome ? "/toolkit/all" : "/home/toolkit/all";
    } else if (checkValidation(org, org.isGroups)) {
      url = isHome ? "/groups" : "/groups";
    }
  }

  // console.log('url---', url)
  return url;
};

export const populateChartFields = [
  "kpiForPlotly",
  "kpiData",
  "createdBy",
  "benchmark",
];

export const uploadPreview = (upload) => {
  let preview,
    isMsIcon = false,
    uploadCss = false,
    isFileType;
  if (upload && upload.type) {
    let { type } = upload;
    type =
      type.ext && type.ext != null
        ? type.ext + type.mime + upload.url
        : type.mime != null
        ? type.mime
        : type;

    if (type.indexOf("image") > -1 || type.indexOf("video") > -1) {
      preview =
        upload.preview && upload.preview != null ? upload.preview : upload.url;
    } else if (
      type.indexOf("csv") > -1 ||
      type.indexOf("spreadsheetml") > -1 ||
      upload.name.indexOf(".xls") > -1 ||
      upload.name.indexOf(".csv") > -1
    ) {
      preview = officeExcelIcon;
      isMsIcon = true;
      uploadCss = "bgExcelContainer";
      isFileType = "Excel/csv";
      // preview = imgContainerPreview("bgExcelContainer", upload)
    } else if (type.indexOf("pdf") > -1 || upload.name.indexOf(".pdf") > -1) {
      preview = officePdfIcon;
      isMsIcon = true;
      uploadCss = "bgPdfContainer";
      isFileType = "PDF";
      // preview = imgContainerPreview("bgPdfContainer", upload)
    } else if (
      type.indexOf("presentation") > -1 ||
      type.indexOf("ppt") > -1 ||
      upload.name.indexOf(".ppt") > -1
    ) {
      preview = officePptIcon;
      isMsIcon = true;
      uploadCss = "bgPptContainer";
      isFileType = "Powerpoint";
      // preview = imgContainerPreview("bgPptContainer", upload)
    } else if (
      type.indexOf("msword") > -1 ||
      type.indexOf("doc") > -1 ||
      upload.name.indexOf(".doc") > -1
    ) {
      preview = officeWordIcon;
      isMsIcon = true;
      uploadCss = "bgWordContainer";
      isFileType = "Word";
      // preview = imgContainerPreview("bgWordContainer", upload)
    } else {
      preview = officeFileIcon;
      isMsIcon = true;
    }
    return { ...upload, preview, isFileType, uploadCss, isMsIcon };
  } else {
    console.log("att 2---- ", upload);
    let type = upload;
    if (typeof type === 'string' && (type.indexOf("csv") > -1 || type.indexOf("spreadsheetml") > -1)) {
      preview = officeExcelIcon;
      isMsIcon = true;
      uploadCss = "bgExcelContainer";
      isFileType = "Excel/csv";
      // preview = imgContainerPreview("bgExcelContainer", upload)
    } else if (typeof type === 'string' && type.indexOf("pdf") > -1) {
      preview = officePdfIcon;
      isMsIcon = true;
      uploadCss = "bgPdfContainer";
      isFileType = "PDF";
      // preview = imgContainerPreview("bgPdfContainer", upload)
    } else if (typeof type === 'string' && (type.indexOf("presentation") > -1 || type.indexOf("ppt") > -1)) {
      preview = officePptIcon;
      isMsIcon = true;
      uploadCss = "bgPptContainer";
      isFileType = "Powerpoint";
      // preview = imgContainerPreview("bgPptContainer", upload)
    } else if ( typeof type === 'string' && (type.indexOf("msword") > -1 || type.indexOf("doc") > -1)) {
      preview = officeWordIcon;
      isMsIcon = true;
      uploadCss = "bgWordContainer";
      isFileType = "Word";
      // preview = imgContainerPreview("bgWordContainer", upload)
    } else {
      preview = officeFileIcon;
      isMsIcon = true;
    }
    // let preview = upload.preview && upload.preview!=null?upload.preview:upload.url
    // return {...upload, preview}
    return { upload, preview, isFileType, uploadCss, isMsIcon };
  }
};

export const newDashboard = {
  title: "",
  customUser: "",
  dropdownOpen: false,
  errMsg: "",
  isArchiveModal: false,
  updatedFields: null,
  invitedUsers: new Array(),
  privacy: "PRIVATE",
  permission: "VIEW",
  preventCreate: false,
  error: false,
  displayUsers: new Array(),
  isPrivacy: false,
  isUserList: false,
  privacyPopoverOpen: false,
  permissionPopoverOpen: false,
  isCreateModal: false,
  isComplete: false,
};

export const task_priority = (priority) => {
  if (priority == 1) {
    return "Low";
  } else if (priority == 2) {
    return "Medium";
  } else if (priority == 3) {
    return "Urgent";
  } else {
    return "None";
  }
};

export const privacyLabel = {
  PRIVATE: "Private",
  OFFICE: "Office",
  OFFICE_AND_CHILDREN: "Department",
  ENTERPRISE: "Everyone",
  CUSTOM: "Shared with specific people",
  GROUP: "Group",
  isRecommendedByAdmin: "Recommended",
};

export const dashboardChartSize = {
  3: { size: "col-lg-3", name: "Small" },
  4: { size: "col-lg-4", name: "Medium" },
  6: { size: "col-lg-6", name: "Large" },
  12: { size: "col-lg-12", name: "Full" },
};

export const checkUploadType = (fileType) => {
  let acceptedFileTypes = [
    "text/csv",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-fontobject",
    "image/gif",
    "image/jpeg",
    "audio/mpeg",
    "video/mpeg",
    "pptx",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.oasis.opendocument.spreadsheet",
    "application/vnd.oasis.opendocument.text",
    "audio/ogg",
    "video/ogg",
    "image/png",
    "application/pdf",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/rtf",
    "image/svg+xml",
    "image/tiff",
    "text/plain",
    "audio/wav",
    "audio/webm",
    "video/webm",
    "image/webp",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
    ".doc",
    ".docx",
    "video/*",
    "audio/*",
    "video/mp4",
    "video",
    "audio",
  ];
  if (
    fileType &&
    fileType != null &&
    (acceptedFileTypes.indexOf(fileType) > -1 ||
      (fileType.indexOf("video") > -1 && fileType.indexOf("quicktime") == -1) ||
      fileType.indexOf("audio") > -1)
  ) {
    return true;
  } else {
    return false;
  }
};

export const groupPrivacyStatusDesc = [
  {
    id: "ENTERPRISE",
    name: "Open",
    description:
      "Group and its related content are visible to anyone on the platform, and anyone can participate in the group.",
    permission: "Anyone can join and any member can invite anyone to join.",
  },

  {
    id: "PRIVATE",
    name: "Private",
    description:
      "Group and all its related content are visible to anyone on the platform, but they have to be invited to engage.",
    permission: "Only Admins can invite members to join.",
  },

  {
    id: "INVITE",
    name: "By Invite Only",
    description:
      "Group and all related content are visible only to those invited to participate in the group",
    permission:
      "Only specific individuals invited to this group can be members.",
  },
];

export const groupContentFields = (value) => {
  return groupPrivacyStatusDesc.filter((e) => e.id == value)[0];
};

export const custom_views = (url, user) => {
  let list = [
    `/home/groups/${user.organizationId._id}/create`,
    `/home/groups/${user.organizationId._id}/view`,
    `/home/groups/${user.organizationId._id}/settings`,
    `/home/trivia/${user.organizationId._id}/edit`,
    `/home/trivia/${user.organizationId._id}/library-item`,
    `/home/dani/slack-app-install`,
  ];

  if (
    url.indexOf("/home/trivia") >= 0 &&
    (url.indexOf("/quiz/") >= 0 || url.indexOf("/preview-quiz/") >= 0)
  ) {
    return true;
  }

  let a = list.filter((e) => {
    if (url.indexOf(e) > -1) {
      return e;
    }
  });

  return a.length > 0;
  // return  url.indexOf(`/home/groups/${user.organizationId._id}`)
};

export const groupMenuValues = [
  { key: 0, name: "My Groups", link: "feed" },
  { key: 1, name: "All Groups", link: "discover" },
  { key: -1, name: "Archived Groups", link: "archived" },
];

export const checkUserPrivileges = (user, reports, action) => {
  if (reports) {
    if (reports && Object.keys(reports).length > 0) {
      if (action == "owner") {
        if (user._id == reports.createdBy._id || user.orgAdmin) {
          return true;
        } else {
          return false;
        }
      } else {
        if (
          user._id == (reports.createdBy && reports.createdBy._id) ||
          user._id == reports.createdBy
        ) {
          return "EDIT";
        } else if (reports.privacy == "PRIVATE") {
          return reports.createdBy._id == user._id;
        } else if (reports.privacy == "ENTERPRISE") {
          return reports.permission == "VIEW" ? false : true;
        } else if (reports.privacy == "CUSTOM") {
          let { invitedUsers } = reports;
          let current_permission;
          invitedUsers.map((e) => {
            if (e.userId == user._id) {
              return (current_permission = e.permissions == 0 ? false : true);
            }
          });
          return current_permission;
        }
      }
    }
  } else {
    return "VIEW";
  }
};

export const canAddToGroup = (item, user) => {
  let current_user = user.hasOwnProperty("profile") ? user.profile : user;

  if (
    item._id &&
    // &&!item.hasOwnProperty('groupId')
    (item.privacy == "ENTERPRISE" ||
      (item.createdBy && item.createdBy._id == current_user._id) ||
      (item.invitedUsers &&
        item.invitedUsers.length > 0 &&
        item.invitedUsers.filter((e) => e.value == current_user._id).length >
          0) ||
      current_user.orgAdmin)
  ) {
    return true;
  }
  return false;
};

export const displayEventDates = (
  event,
  isFullDate,
  showHours,
  is_short_format
) => {
  let res, format;

  if (isFullDate) {
    if (is_short_format) {
      format = {
        sameDay: "ddd, MMM Do YYYY [at] h:mm a",
        diffDay: "ddd, MMM Do YYYY",
        diffYear: "ddd, MMM Do YYYY",
      };
    } else {
      format = {
        sameDay: "dddd, MMMM Do YYYY [at] h:mm a",
        diffDay: "dddd, MMMM Do YYYY",
        diffYear: "dddd, MMMM Do YYYY",
      };
    }
  } else {
    format = {
      sameDay: "ddd, MMM Do YYYY [at] h:mm a",
      diffDay: "ddd, MMM Do YYYY",
      diffYear: "ddd, MMM Do YYYY",
    };
  }
  let dformat = showHours ? format.sameDay : format.diffDay;

  if (event.startDate && event.endDate) {
    let { startDate, endDate } = event;
    let isSameYear =
      moment(startDate).format("YYYY") == moment(endDate).format("YYYY");
    if (isSameYear) {
      let isSameDay = moment(startDate).isSame(moment(endDate), "day");
      if (isSameDay) {
        if (moment(startDate).isSame(moment(endDate))) {
          res = `${moment(startDate).format(format.sameDay)}`;
        } else {
          res = `${moment(startDate).format(format.sameDay)} - ${moment(
            endDate
          ).format("h:mm a")}`;
        }
      } else {
        res = `${moment(startDate).format(dformat)} - ${moment(endDate).format(
          dformat
        )}`;
      }
    } else {
      res = `${moment(startDate).format(format.diffYear)} - ${moment(endDate).format(
        format.diffYear
      )}`;
    }
  } else if (event.startDate && !event.endDate) {
    let { startDate } = event;
    res = `${moment(startDate).format(dformat)}`;
  } else {
    res = "No date provided";
  }
  return res;
};

export const calculateTotalRsvp = (event, type) => {
  let { going_count, interested_count, invitee_count } = event;
  going_count = isNaN(going_count) ? 0 : going_count;
  invitee_count = isNaN(invitee_count) ? 0 : invitee_count;
  interested_count = isNaN(interested_count) ? 0 : interested_count;
  let total_people_responded;

  if (type == "invited") {
    total_people_responded = invitee_count;
  } else if (type == "rsvp") {
    total_people_responded = going_count + interested_count;
    total_people_responded = parseInt(total_people_responded);
  } else if (type == "going") {
    total_people_responded = going_count;
  } else if (type == "interested") {
    total_people_responded = interested_count;
  }

  return isNaN(total_people_responded) ? 0 : total_people_responded;
};

export const getDuration = (event) => {
  let { startDate, endDate } = event;
  endDate = moment(endDate);
  startDate = moment(startDate);

  let years = endDate.diff(startDate, "years");
  let months = endDate.diff(startDate, "months");
  let weeks = endDate.diff(startDate, "weeks");
  let days = endDate.diff(startDate, "days");
  let hours = endDate.diff(startDate, "hours");
  let min = endDate.diff(startDate, "minutes");

  // console.log(startDate)
  // console.log(endDate)

  // console.log(min, hours, days)

  if (hours <= 24 && days < 1) {
    if (min % 60 != 0) {
      if (min > 60) min = min % 60;
      return `${hours} hr ${min} min`;
    } else {
      return `${hours} hr`;
    }
  } else if (days >= 1 && days < 7) {
    return `${days} days`;
  } else if (days >= 7 && months < 1) {
    return `${weeks} weeks`;
  } else if (months >= 1 && months < 12) {
    return `${months} months`;
  } else if (months >= 12) {
    return `${years} years`;
  }
};

export const create_event_hosts = (current_user, host, event, group) => {
  let { startDate, endDate, name, _id, category } = event;
  let event_item = {
      startDate,
      endDate,
      name,
      eventId: _id,
      category,
      invitedBy: current_user._id,
    },
    rsvp_status = "INVITED",
    event_status = "ADMIN";

  if (current_user._id == host._id) {
    delete event_item.invitedBy;
    rsvp_status = "GOING";
    event_status = "OWNER";
  }

  // let rsvp_status = current_user._id == host._id? 'GOING':'INVITED'
  // let event_status = current_user._id == host._id? 'OWNER':'ADMIN'

  let event_host = {
    ...event_item,
    // email:host.email,
    // profilePic: host.profilePic,
    firstName: host.firstName,
    lastName: host.lastName,
    email: host.email,
    userId: host._id,
    organizationId: current_user.organizationId._id,
    date: new Date(),
    permissions: 1,
    rsvp: rsvpRoles.filter((e) => e.id == rsvp_status)[0],
    role: eventRoles.filter((e) => e.id == event_status)[0],
  };
  if ((event && event.hasOwnProperty("groupId")) || (group && group.groupId)) {
    event_host = {
      ...event_host,
      groupId: group.groupId,
    };
  }

  return event_host;
};

export const rsvpRoles = [
  { value: 3, label: "Decline", id: "DECLINE" },
  { value: 1, label: "Interested", id: "INTERESTED" },
  { value: 2, label: "Going", id: "GOING" },
  // { value:1, label :'Maybe',name :'Maybe' , isHidden:true},

  { value: 1000, label: "Click to RSVP", isHidden: true, id: "RSVP" },
  { value: 0, label: "Invited", isHidden: true, id: "INVITED" },
  // {value:-1, label:'Removed', isHidden:true, id:'REMOVED'}
];

// repost to stories or Boost is an event with a reaction & comment for admin of event
export const eventActionRoles = [
  { value: 0, label: "Support & repost or boost" },
  { value: 1, label: "Volunteer" },
  { value: 2, label: "Going" },
  { value: 1000, label: "Member" },
];

export const eventRoles = [
  { value: 0, name: "Host", label: "Admin", isHidden: true, id: "OWNER" },
  { value: 1, name: "Host", label: "Admin", id: "ADMIN" }, // --> host
  { value: 2, label: "Moderator", id: "MOD" },
  // { value :3,label :'Host', id: 'HOST'},
  { value: 1000, label: "Member", id: "MEM" },
];

export const groupRoles = [
  { value: 0, label: "Group Admin", role: "Admin", isHidden: true },
  {
    value: 1,
    label: "Group Admin",
    role: "Admin",
    description:
      "In addition to moderators, Admins can change all settings of the Group",
  },
  {
    value: 2,
    label: "Group Moderator",
    role: "Moderator",
    description:
      "In addition to member privileges, Moderators can remove any story, event, analytics, resources or member except admins",
  },

  {
    value: 1000,
    label: "Group Member",
    role: "Member", // Keep member as last one here
    description:
      "Members can post/remove their own stories and link/create/remove their events, analytics, resources, and invite members",
  },
];

// role:this.props.currentRole, action:0, comparison:null, isAdmin:this.props.currentRole==0
export const groupRolePriviledge = (results) => {
  let { role, action, comparison, isAdmin, role_priv, group } = results;
  if (group && group.isArchived) {
    return false;
  } else {
    if (comparison == null || comparison == undefined || !comparison) {
      if (isAdmin) {
        return role == 1 || role == 0;
      } else if (role_priv && role_priv.length > 0) {
        return role_priv.indexOf(role) > -1;
      } else {
        return action > role;
      }
    } else if (comparison && comparison.length > 0) {
      if (comparison.includes("<")) {
        return role < action;
      } else if (comparison.includes(">")) {
        return role > action;
      } else if (comparison.includes("==")) {
        return role == action;
      }
    }
  }
};

export const groupRoleAlerts = (results) => {
  let { role, privacy, inviteOnly } = results;
  if (role == -1) {
    // not a member of group
    if (privacy == "ENTERPRISE") {
      return "Please join the group to participate";
    } else if(privacy=="PRIVATE"){
      return "Private"
    } else {
      if (inviteOnly) {
        return "Invite only";
      }
      return "You must be invited to participate in this group";
    }
  }
};

// export const groupRsvp = [
//   // {value:3, label: 'Request Sent', isHidden:true},
//   { value: 4, action: "JoinAnonymously", label: "Join Group Anonymously", isDiscover: true },
//   { value: 3, action: "Leave", label: "Leave Group", isFeed: true },

//   { value: 1, label: "Join", isFeed: true, isDiscover: true },
//   { value: 0, action: "Join", label: "Join Group", isDiscover: true },
// ];

export const groupRsvp = (allowAnonymous) => {
  let res = [
    // {value:3, label: 'Request Sent', isHidden:true},
    { value: 3, action: "Leave", label: "Leave Group", isFeed: true },

    {
      value: 1,
      label: "Join",
      isFeed: true,
      isDiscover: true,
      joined_status: "Joined",
    },
    { value: 0, action: "Join", label: "Join Group", isDiscover: true },
  ];

  if (allowAnonymous) {
    res = [
      ...res,
      {
        value: 4,
        action: "JoinAnonymously",
        label: "Join Group Anonymously",
        isDiscover: true,
        isAnonymous: true,
        joined_status: "Joined Anonymously",
      },
    ];
  }

  return res;
};

export const createGroupMember = (
  user,
  invitedBy,
  joined_date,
  role_type,
  anonymousMember
) => {
  console.log("u---", user);
  let obj = {
    email: user.email,
    profilePic: profilePicValidityCheck(user.profilePic)
      ? user.profilePic
      : null,
    firstName: user.firstName,
    lastName: user.lastName,
    o_id: user._id,
    role:
      role_type == "Admin"
        ? 0
        : groupRoles.filter((e) => e.role == role_type)[0].value,
    orgId:
      typeof user.organizationId == "object"
        ? user.organizationId._id
        : user.organizationId,
    date: joined_date,
    isAnonymous: anonymousMember,
  };
  if (invitedBy) {
    obj = { ...obj, invitedBy };
  }
  return obj;
};

const hexToRGBA = (hex, opacity) => {
  return (
    "rgba(" +
    (hex = hex.replace("#", ""))
      .match(new RegExp("(.{" + hex.length / 3 + "})", "g"))
      .map(function(l) {
        return parseInt(hex.length % 2 ? l + l : l, 16);
      })
      .concat(isFinite(opacity) ? opacity : 1)
      .join(",") +
    ")"
  );
};

export const checkWhiteLabel = (value, fields) => {
  if (fields && value) {
    // let{brandColor}=org.whiteLabel
    // brandColor='green'
    // let a =  {[field]: value}
    // list of fields, insert value--> fields.reduce((a,v)=> ( {...a, [v]:  brandColor}), {})
    // let b = fields.reduce((a,v)=> ( {...a, [v]:  `${value}`}), {})
    // console.log('b---', b)
    return value;
  }
};

export const chartLineColor = (trace) => {
  return color_palette[trace];
};

export const get_max_plot_ticks = (width) => {
  if (width == 30) {
    return 4;
  }
};

const modify_dTick_count = (chart_width, periods, format) => {
  if (chart_width != null && chart_width != undefined) {
    if (chart_width < 0.4) {
      return periods > 6 ? "M12" : format;
    }
  } else {
    return format;
  }
};

export const dtickFormat = (minDate, maxDate, timePeriods, chart_width) => {
  let mnDate = moment(minDate);
  let mxDate = moment(maxDate);
  // console.log(mxDate, mnDate)
  let dateDiff = parseInt(mxDate.diff(mnDate, "month"));
  // console.log(dateDiff, mxDate.diff( mnDate, 'days' ))
  // console.log(chart_width, "--dateD0ff ---", dateDiff);

  if (dateDiff < 1) {
    let dayCount = mxDate.diff(mnDate, "days");
    // let markerCount = timePeriods
    // console.log(dayCount,'--days--',timePeriods)

    if (dayCount > 15) {
      return day * 7;
    } else if (dayCount > 5) {
      return day * 3;
    } else {
      return day;
    }
  } else if (dateDiff >= 1 && dateDiff <= 3) {
    return "M1";
  } else if (dateDiff > 3 && dateDiff <= 12) {
    return modify_dTick_count(chart_width, dateDiff, "M3");
  } else if (dateDiff > 12 && dateDiff <= 24) {
    return modify_dTick_count(chart_width, dateDiff, "M4");
  } else if (dateDiff > 25 && dateDiff <= 36) {
    if (timePeriods > 7) {
      return "M12";
    }
    return "M6";
  } else {
    return "M12";
  }
};

// export const dtickFormat = (minDate, maxDate, timePeriods) =>{
//     let mnDate = moment(minDate)
//     let mxDate = moment(maxDate)
//     let dateDiff = parseInt(mxDate.diff( mnDate, 'month' ))

//     if(dateDiff < 1){
//         let dayCount = mxDate.diff( mnDate, 'days' )

//         if(dayCount>15) {
//             return day*7
//         } else if (dayCount>5){
//             return day*3
//         } else {
//             return day
//         }
//     } else if (dateDiff>=1 && dateDiff<=3){
//         return 'M1'
//     } else if (dateDiff>3 && dateDiff<=12){
//         return 'M3'
//     } else if (dateDiff>12 && dateDiff<=24){
//         return 'M4'
//     } else if (dateDiff>25 && dateDiff<=36){
//         if(timePeriods>7){
//             return 'M12'
//         }
//         return 'M6'
//     }else {
//         return 'M12'
//     }
// }

export const legendPosition = (kpiCount) => {
  let yLegend;
  if (kpiCount < 3) {
    yLegend = -0.6;
  } else if (kpiCount >= 3 && 6 > kpiCount) {
    yLegend = -0.7;
  } else if (kpiCount >= 6 && 9 > kpiCount) {
    yLegend = -0.9;
  } else if (kpiCount >= 9 && 11 > kpiCount) {
    yLegend = -1.2;
  } else if (kpiCount >= 11) {
    yLegend = -1.4;
  }

  return -0.4;
};

export const isDateInRange = (date, startDate, endDate) => {
  date = new Date(moment(new Date(date)).format("MM/DD/YYYY"));
  startDate = new Date(moment(new Date(startDate)).format("MM/DD/YYYY"));
  endDate = new Date(moment(new Date(endDate)).format("MM/DD/YYYY"));

  return date >= startDate && date <= endDate;
};

export const sortActionsByDate = (tasks) => {
  let res = orderBy(
    tasks,
    [
      ({ dueDate, lastUpdate, createdOn, completedDate }) =>
        dueDate &&
        moment(dueDate).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD") &&
        completedDate == null
          ? 1
          : dueDate &&
            moment().diff(dueDate, "days") == 0 &&
            completedDate == null
          ? 1
          : dueDate &&
            moment().diff(dueDate, "days") > 0 &&
            completedDate == null
          ? 1
          : dueDate && (lastUpdate || createdOn) && completedDate == null
          ? 1
          : dueDate == null && lastUpdate && completedDate == null
          ? 1
          : dueDate == null &&
            lastUpdate == null &&
            completedDate == null &&
            createdOn
          ? 1
          : completedDate && dueDate
          ? -1
          : dueDate == null && completedDate
          ? -1
          : 1,
      "dueDate",
      "lastUpdate",
      "createdOn",
      "completedDate",
    ],
    ["asc", "desc", "desc", "desc"]
  ).reverse();
  return res;
};

export const actionsByStatus = (tasks, status) => {
  console.log(status, "--tasks---", tasks);
  if (status === "A") {
    return tasks;
  } else if (status == "P") {
    return filter(tasks, (t) => {
      return t.status == 2;
    });
  } else if (status == "I") {
    return filter(tasks, (t) => {
      return t.status == 1;
    });
  } else if (status == "C") {
    return filter(tasks, (t) => {
      return t.status == 3;
    });
  } else if (status == "O") {
    return filter(tasks, (t) => {
      return (
        t.isDeleted != true &&
        !t.completedDate &&
        t.dueDate &&
        t.dueDate != null &&
        t.dueDate != undefined &&
        moment(t.dueDate).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")
      );
    });
  }
};

export const isUserRemoved = (user) => {
  if (user.firstName == "" || user.status == "INACTIVE" || user.isDeleted) {
    return true;
  }
  return false;
};

export const taskValidation = (task) => {
  let errors = [];

  let isTitle =
    task.title && task.title != undefined && task.title != null
      ? task.title.replace(/<\/?[^>]+(>|$)/g, "")
      : "";

  let isDesc =
    task.description &&
    task.description != undefined &&
    task.description != null
      ? task.description.replace(/<\/?[^>]+(>|$)/g, "")
      : "";

  if (isTitle.length == 0) {
    errors.push("Title cannot be empty");
  }

  if (isDesc.length == 0) {
    errors.push("Description cannot be empty");
  }

  if (task.dueDate) {
    if (
      !task.createdOn &&
      moment(task.dueDate).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")
    ) {
      errors.push("Due date cannot be set in the past");
    }
  }

  return errors;
};

export const KPISbyMonth = [
  "HRT-1",
  "HRT-2",
  "HRT-4",
  "HRT-5",
  "HRT-6",
  "HRT-7",
  "COMP-2",
  "GRO-1",
];

export const diversityCategories = [
  "ageEnd",
  "ageStart",
  "ethnicityType",
  "veteranType",
  "sexualOrientationType",
  "religionType",
  "disabilityType",
  "diversityType",
];

export const hierarchyChangeNotifications = {
  isRemoved: "Office was removed from Org Chart",
};

export const diversityTypes = [
  "ageEnd",
  "ageStart",
  "ethnicity",
  "veteran",
  "sexualOrientation",
  "religion",
  "disability",
  "gender",
];

export const taskValues = [
  { key: 1, name: "Stories", link: "stories" },
  // {key:1, name:"My Actions",link:"my-activity"},
  // {key:1, name:"My Office",link:"office-activity"},
  // {key:1, name:"Enterprise",link:"enterprise-objective"},
  // {key:1, name:"Stories",link:"user-stories"}
];

export const planningValues = [
  {
    key: 0,
    name: "My Actions",
    link: "my-activity",
    selected: ["planning", "my-activity"],
    typeOf: "personal",
    apiType: "myActions",
  },
  {
    key: 2,
    name: "Public Actions",
    link: "public-activity",
    selected: ["planning", "public-activity"],
    typeOf: "public",
    apiType: "publicActions",
  },
  {
    key: 3,
    name: "Archived Actions",
    link: "archived-activity",
    selected: ["planning", "archived-activity"],
    typeOf: "archived-activity",
    apiType: "archivedActions",
  },
  {
    key: 1,
    name: "Objectives",
    link: "enterprise-objective",
    selected: ["enterprise-associatedActions", "enterprise-objective"],
    typeOf: "objectives",
  },
];

export const dashboardMenuValues = [
  // {key:1, name:"Stories",link:"stories"},
  { key: 1, name: "Manage", link: "dashboard-list" },
  // {key:1, name:"My Office",link:"office-activity"},
  { key: 2, name: "Customize", link: "dashboard-library" },
  // {key:1, name:"Stories",link:"user-stories"}
];

export const staticTitles = {
  stories: "Culture App",
  storyItemsU: "Posts",
  storyItemsL: "posts",
  toolkit_sm: "resource",
  toolkit_sm_pl: "resources",
  toolkit_lg: "Resource",
  toolkit_lg_pl: "Resources",
  toolkit_item: "item",
  dashboardMenu: "Dashboard",
  cultureAppInfo: "Share experiences, ideas and resources",
  onBoardingModal:
    "Welcome to the Culture App, a safe space for you to make your voice heard, understand others and build the inclusive workplace culture you want to see! \n \n Note you have the option to engage anonymously and your profile information is always private. \n \n So have fun connecting, sharing and engaging.",
};

export const diversityFocusOptions = [
  { type: "ethnicity", name: "Ethnicity" },
  { type: "religion", name: "Religion" },
  // {type: "birthDate", name: "Birth Date"},
  { type: "disability", name: "Disability" },
  { type: "veteran", name: "Veteran" },
  { type: "sexualOrientation", name: "Sexual Orientation" },
  { type: "occupation", name: "Occupation" },
  { type: "seniority", name: "Seniority" },
  { type: "gender", name: "Gender" },
];

export const storyValues = [
  { key: 1, name: "My Posts", link: "me" },
  // { key: 2, name: "Inbox", link: "inbox" },
  { key: 3, name: "Enterprise", link: "" },
  { key: 4, name: "Trending", link: "trending" },
  { key: 5, name: "Archive", link: "archived" },
  { key: 5, name: "Reporting", link: "reporting" },
];

export const noLoaderUrls = ["notification", "stories/sentiment"];

export const filtersData = [
  {
    _id: "1",
    filterValues: [
      {
        key: "5b3f072b21111654108f59d7",
        category: "All",
      },
      {
        key: "5b4aff2a35102e0a59218539",
        category: "Gender",
      },
      {
        key: "5cf31d6f1c9d44000034faa0",
        category: "Religion",
      },
      {
        key: "5cf31d801c9d44000034faa1",
        category: "Age",
      },
      {
        key: "5b3f072b21111654108f59d9",
        category: "Ethnicity / Race",
      },
      {
        key: "5b3f072b21111654108f59da",
        category: "LGBTQ",
      },
      {
        key: "5b484fb671384e7a4dfc8aa6",
        category: "Sexual Orientation",
      },
      {
        key: "5b3f072b21111654108f59db",
        category: "Veterans",
      },
      {
        key: "5b484fb671384e7a4dfc8aa8",
        category: "Disability",
      },
      {
        key: "5b3f072b21111654108f59dd",
        category: "Other",
      },
    ],
  },
  {
    _id: "2",
    filterValues: [
      {
        key: "5b3f08558cf40620dc6117b8",
        category: "All",
      },
      {
        key: "5b3f08558cf40620dc6117b9",
        category: "Board",
      },
      {
        key: "5b3f08558cf40620dc6117ba",
        category: "Executives",
      },
      {
        key: "5b3f08558cf40620dc6117bb",
        category: "Managers",
      },
      {
        key: "5b3f08558cf40620dc6117bc",
        category: "Non-managers",
      },
      {
        key: "5b3f08558cf40620dc6117bd",
        category: "Technical",
      },
      {
        key: "5b3f08558cf40620dc6117be",
        category: "Salaried",
      },
      {
        key: "5b3f08558cf40620dc6117bf",
        category: "Hourly",
      },
    ],
  },
  { _id: "6" },
];

export const toolkitCategoryFilterMapping = [
  { key: "2", type: "relevantFor", display: "Aimed at" },
  { key: "1", type: "diversityFocus", display: "Diversity" },
  { key: "3", type: "createdBy", display: "Created by" },
  { key: "4", type: "category", display: "Category" },
  { key: "5", type: "subCategory", display: "Subcategory" },
  { key: "6", type: "eventDates", display: "Event Date" },
  { key: "7", type: "location", display: "Location" },
  { key: "8", type: "distance", display: "Distance" },
];

// export const getDisplayByKey = (category) => {
//     return find(toolkitCategoryFilterMapping,(o) => o.key === category.categoryGrouping).focus;
// }
export const getDisplayByKey = (key) => {
  return find(toolkitCategoryFilterMapping, (o) => o.key === key).display;
};

// export const getTypeByKey = (category) => {
//     // console.log('getByKey --- ', category)
//     let{categoryGrouping}=category, type;
//     categoryGrouping= categoryGrouping!=""&&categoryGrouping!=null?categoryGrouping:category
//     //   return find(toolkitCategoryFilterMapping,(o) => o.key === key).type;
//     if(categoryGrouping === '1'){
//         type= 'diversityFocus'
//     } else if (categoryGrouping === '2') {
//         type= 'relevantFor'
//     }else if (categoryGrouping === '4') {
//         type= 'category'
//     }else if (categoryGrouping === '3') {
//         type= 'createdBy'
//     }else if (categoryGrouping === '5') {
//         // {subCategoryKey : "n/a",subCategoryValue : "n/a"}
//         type= 'subCategory'
//     }else{
//         type= find(toolkitCategoryFilterMapping,(o) => o.key === categoryGrouping).type;
//     }
//     console.log('type: ', type)
//     return type
// }

export const getTypeByKey = (key) => {
  return find(toolkitCategoryFilterMapping, (o) => o.key === key).type;
};

export const toolkitCategoryFilterValues = [
  { key: "All", category: "All" },
  { key: "Best Practices", category: "Best Practices" },
  { key: "Associations", category: "Associations" },
  { key: "Workplace Culture", category: "Workplace Culture" },
  { key: "Conferences & Events", category: "Conferences & Events" },
  //   {key : 'Consultants', category : 'Consultants'},
  { key: "Employee Groups", category: "Employee Groups" },
  { key: "Policies & Benefits", category: "Policies & Benefits" },
  { key: "Programs & Initiatives", category: "Programs & Initiatives" },
  //   {key : 'Programs & Initiatives', category : 'Programs & Initiatives'},
  { key: "Recruitment & Hiring", category: "Recruitment & Hiring" },
  { key: "Training & Development", category: "Training & Development" },
  { key: "Workplace Culture", category: "Workplace Culture" },
  { key: "Diversity Calendar", category: "Diversity Calendar" },
];

export const analyticsCategoryFilterValues = [
  { key: "All", category: "All" },
  { key: "Business & Culture", category: "Business & Culture" },
  { key: "Compensation", category: "Compensation" },
  { key: "Employee Growth", category: "Employee Growth" },
  { key: "Hiring & Retention", category: "Hiring & Retention" },
  { key: "Processes & Policies", category: "Processes & Policies" },
  { key: "Representation", category: "Representation" },
];

export const getAppliedFiltersCount = (filters) => {
  let count = 0;
  for (let key in filters) {
    let filter = filters[key];
    if (filter && filter.length > 0) {
      count = count + 1;
    } else if (key === "chartCreatedBy" && filter && filter._id) {
      count = count + 1;
    }
  }
  return count;
};

export const UserRole = {
  admin: "Admin",
  enterpriseAdmin: "EnterpriseAdmin",
  superAdmin: "SuperAdmin",
  user: "User",
};

export const roleOptions = [
  {
    orgAdmin: true,
    value: "Enterprise Admin",
    label: "Enterprise Admin",
    definition:
      "Enterprise Admin can access, create and modify how data and various modules are presented on the platform",
  },
  {
    orgAdmin: false,
    value: "Admin",
    label: "Admin",
    definition:
      "Admin can access and create any item or data on the platform. Specifically, this enables the ability to create reports.",
  },
  {
    orgAdmin: false,
    value: "User",
    label: "User",
    definition: "Users can create items in all modules except reports.",
  },
  // {
  //   orgAdmin: false,
  //   value: "Member",
  //   label: "Member",
  //   definition: "Members can create items in all modules except reports.",
  // },
];

export const UserRoles = [
  { orgAdmin: true, key: "Enterprise Admin", value: "Enterprise Admin" },
  { key: "Member", value: "Member" },
  { key: "User", value: "User" },
  { key: "Admin", value: "Admin" },
];

export const addToolStep = {
  info: "Info",
  focus: "Focus",
  locationAndContact: "LocationAndContact",
  privacy: "Privacy",
  preview: "Preview",
};

export const createChartStep = {
  details: "Details",
  benchmark: "Benchmark",
  privacy: "Privacy",
};

export const editChartStep = {
  ...createChartStep,
};

export const chartStep = {
  ...createChartStep,
};

export const officeSetupSteps = ["Personal Details", "Invite Your Officemates"];
// export const officeSetupSteps = ['Personal Details','Office Details','Invite Your Officemates'];

export const manualDataEntrySteps = [
  "Select Date",
  "Employee Lifecycle",
  "Business & Culture",
  "Processes & Policies",
  "Board",
  "Review & Finish",
];

export const getSubcategories = (category) => {
  // console.log(category);
  if (category === CATEGORY_BEST_PRACTICES) {
    let bestPracticesSubCategories = [
      "Compensation",
      "Growth & Performance",
      "Hiring & Retention",
      "Processes & Policies",
      "Representation",
      "Business & Culture",
    ];
    return bestPracticesSubCategories.map((category) => {
      return { subCategoryKey: category, subCategoryValue: category };
    });
  } else if (category === CATEGORY_CONFERENCES_AND_EVENTS) {
    let eventsSubCategories = [
      "Conferences",
      "Forums",
      "Meetings",
      "Networking",
      "Talks and Panels",
    ];
    return eventsSubCategories.map((category) => {
      return { subCategoryKey: category, subCategoryValue: category };
    });
  } else if (category === CATEGORY_WORKPLACE_CULTURE) {
    let communicationsSubCategories = ["Communications", "Surveys"];
    return communicationsSubCategories.map((category) => {
      return { subCategoryKey: category, subCategoryValue: category };
    });
  } else if (category === CATEGORY_POLICIES_AND_BENEFITS) {
    let policiesAndHandbooksSubCategories = [
      "Compensation",
      "Family Support",
      "Sexual Harassment",
      "Talent Management",
      "Training & Development",
      "Work Flexibility",
      "Workplace Diversity & Inclusion",
    ];
    return policiesAndHandbooksSubCategories.map((category) => {
      return { subCategoryKey: category, subCategoryValue: category };
    });
  } else if (category === CATEGORY_PROGRAMS_AND_INITIATIVES) {
    let programsAndInitiativesSubCategories = [
      "Compensation",
      "Growth & Performance",
      "Hiring & Retention",
      "Processes & Policies",
      "Representation",
      "Business & Culture",
    ];
    return programsAndInitiativesSubCategories.map((category) => {
      return { subCategoryKey: category, subCategoryValue: category };
    });
  } else if (category === CATEGORY_RECRUITMENT_AND_HIRING) {
    let recruitmentAndHiringSubCategories = [
      "Career Fairs",
      "Job Boards",
      "Recruiters",
      "Software Products",
    ];
    return recruitmentAndHiringSubCategories.map((category) => {
      return { subCategoryKey: category, subCategoryValue: category };
    });
  } else if (category === CATEGORY_TRAINING_AND_DEVELOPMENT) {
    let traningSubCategories = [
      "Online Training",
      "Mentors & Coaches",
      "Workshops & Classes",
      "Software Products",
    ];
    return traningSubCategories.map((category) => {
      return { subCategoryKey: category, subCategoryValue: category };
    });
  } else {
    return [];
  }
};

export const CATEGORY_ASSOCIATIONS = "Associations";
export const CATEGORY_ERGS = "Employee Groups";
export const CATEGORY_PROGRAMS_AND_INITIATIVES = "Programs & Initiatives";
export const CATEGORY_CONFERENCES_AND_EVENTS = "Conferences & Events";
export const CATEGORY_WORKPLACE_CULTURE = "Workplace Culture";
// export const CATEGORY_CONSULTANTS = 'Consultants';
export const CATEGORY_POLICIES_AND_BENEFITS = "Policies & Benefits";
export const CATEGORY_TRAINING_AND_DEVELOPMENT = "Training & Development";
export const CATEGORY_RECRUITMENT_AND_HIRING = "Recruitment & Hiring";
export const CATEGORY_BEST_PRACTICES = "Best Practices";
export const CATEGORY_DIVERSITY_CALENDAR = "Diversity Calendar";

export const toolkitSteps = [
  "Tool Info",
  "Tool Focus",
  "Contact",
  "Privacy Settings",
];
// export const analyticsSteps = ['KPIs and Dates', 'Benchmarks' ,'Chart Title and Privacy Settings'];
export const analyticsSteps = [
  "KPIs and Dates",
  "Chart Title and Privacy Settings",
];

export const importOrgChartSteps = [
  "Upload File",
  "Match Columns",
  "Map Hierarchy",
  // 'Pick Your Office',
  "Review & Import",
];

export const mapGenderSteps = [
  "Upload File",
  "Match Columns",
  "Map Genders",
  "Review & Finish",
];
export const mapSeparationSteps = [
  "Upload File",
  "Match Columns",
  "Map Separation",
  "Review & Finish",
];
export const mapPositionsSteps = [
  "Upload File",
  "Match Columns",
  "Map Occupations",
  "Map Job Category",
  "Review & Finish",
];
export const mapPerformanceSteps = [
  "Upload File",
  "Match Columns",
  "Map Performance",
  "Review & Finish",
];
export const mapEthnicitySteps = [
  "Upload File",
  "Match Columns",
  "Map Ethnicity/Race",
  "Review & Finish",
];
export const mapVeteranSteps = [
  "Upload File",
  "Match Columns",
  "Map Veteran Status",
  "Review & Finish",
];
export const mapSexualOrientationSteps = [
  "Upload File",
  "Match Columns",
  "Map Sexual Orientation",
  "Review & Finish",
];
export const mapReligionSteps = [
  "Upload File",
  "Match Columns",
  "Map Religion",
  "Review & Finish",
];
export const mapDisabilitySteps = [
  "Upload File",
  "Match Columns",
  "Map Disability",
  "Review & Finish",
];

export const uploadEmployeeDataSteps = [
  "Upload File",
  "Match Columns",
  "Review & Import",
];

export const toolkitFields = [
  "_id",
  "name",
  "category",
  "subCategory",
  "description",
  "website",
  "image",
  "attachment",
  "sponsersName",
  "noOfMembers",
  "startDate",
  "endDate",
  "selectedLocations",
  "references",
  "diversityFocus",
  "relevantFor",
  "diversityFocusTags",
  "relevantForTags",
  "toolkitTags",
  "address",
  "contactName",
  "contactEmailID",
  "contactPhone",
  "latitude",
  "longitude",
  "privacy",
  "permission",
  "isSharedWithOrg",
];

// '#' + (Math.random().toString(16) + "000000").substring(2,8)
export const plotlyLineMarker = (random) => {
  // Math.random()
  let color = "#" + (random + "000000").substring(2, 8);
  let object = {
    color,
    width: 2,
    size: 14,
    symbol: "circle",
  };
  return object;
};

export const plotlyLineTypes = [
  {
    color: "#1EC4B4",
    width: 2,
  },
  {
    color: "#F2994A",
    width: 2,
  },
  {
    color: "#BB6BD9",
    width: 2,
  },
  {
    color: "#F06292",
    width: 2,
  },
  {
    color: "#DC3545",
    width: 2,
  },
  {
    color: "#FFC107",
    width: 2,
  },
  {
    color: "#6F42C1",
    width: 2,
  },
];

export const plotlyMarkerTypes = [
  {
    color: "#1EC4B4",
    size: 16,
    symbol: "circle",
  },
  {
    color: "#F2994A",
    size: 14,
    symbol: "square",
  },
  {
    color: "#BB6BD9",
    size: 12,
    symbol: "triangle-up",
  },
  {
    color: "#1EC4B4",
    size: 13,
    symbol: "circle-open-dot",
  },
  {
    color: "#C262F0",
    size: 13,
    symbol: "diamond",
  },
  {
    color: "#F06292",
    size: 12,
    symbol: "square",
  },
  {
    color: "#DC3545",
    size: 12,
    symbol: "circle",
  },
  {
    color: "#FFC107",
    size: 12,
    symbol: "diamond",
  },
  {
    color: "#6F42C1",
    size: 12,
    symbol: "triangle-up",
  },
];

// https://plotly.com/python/marker-style/#:~:text=The%20marker_symbol%20attribute%20allows%20you,hash%20%2C%20y%20%2C%20and%20line%20.

export const chartMarkerSymbols = [
  "circle",
  "square",
  "diamond",
  "triangle",
  "pentagon",
  "star",
  "diamond",
  "hourglass",
  "bowtie",
];

export const chartMarkerSymbolsVariation = ["", "-open-dot", "-dot"];

export const benchmarkLineTypes = [
  {
    color: "#1EC4B4",
    width: 2,
    dash: "dot",
  },
];

export const toolPrivacy = {
  private: "PRIVATE",
  office: "OFFICE",
  officeAndChildren: "OFFICE_AND_CHILDREN",
};

export const chartPrivacy = {
  private: "PRIVATE",
  office: "OFFICE",
  officeAndChildren: "OFFICE_AND_CHILDREN",
};

export const benchmarks = {
  industry: [
    {
      name: "Aerospace & Defense",
      value: "Aerospace & Defense.",
    },
    {
      name: "Aerospace & Defense2",
      value: "Aerospace & Defense2",
    },
    {
      name: "Aerospace & Defense3",
      value: "Aerospace & Defense3",
    },
  ],
};

export const notificationItemType = {
  tool: "TOOLKIT",
  chart: "CHART",
  story: "STORIES",
  task: "TASK",
  group: "GROUPS",
  trivia: "TRIVIA",
};

export const notificationMessageType = {
  itemCommented: "ITEM_COMMENTED",
  itemShared: "ITEM_SHARED",
  userMentioned: "USER_MENTIONS",
  storyResponse: "STORIES_RESPONSE",
  storyReaction: "STORIES_REACTION",
  announcementReaction: "ANNOUNCEMENT_REACTION",
  // sharedYourItem:"OWNER_ITEM_SHARED",
  itemSharedWithYou: "ITEM_SHARED_WITH_YOU",
  itemSharedPublicly: "ITEM_SHARED_PUBLICLY",
  itemEdited: "ITEM_EDITED",
  officeMateJoined: "OFFICE_MATE_JOINED",
  itemSharedWithOffice: "ITEM_SHARED_WITH_OFFICE",
  recommendedToolAdded: "RECOMMENDED_TOOL_ADDED",
  taskAssigned: "ASSIGNED_TASK",
  taskLinked: "LINK_TASK",
  taskUnlinked: "UNLINK_TASK",
  taskCreated: "CREATE_TASK",
  taskUpdate: "UPDATE_TASK",
  taskCompleted: "COMPLETED_TASK",
  taskIncomplete: "INCOMPLETE_TASK",
  taskArchived: "ARCHIVED_TASK",
  group_invite: "GROUP_INVITE",
  tool_invite: "EVENT_INVITE",
  story_flagged: "STORY_FLAGGED",
  comment_flagged: "COMMENT_FLAGGED",
  trivvyInvited: "INVITED_FOR_TRIVIA",

  // taskUpdate:[ 'ASSIGNED_TASK' ,'LINK_TASK', 'UNLINK_TASK','CREATE_TASK','UPDATE_TASK'
  // ,'COMPLETED_TASK', 'INCOMPLETE_TASK', 'ARCHIVED_TASK']
};

export const uploadFileInstruction = {
  mapReligion:
    "Please upload a .csv file with the religion information about your employees. Next we will ask you to map the information to standardized categories.",
  mapVeteran:
    "Please upload a .csv file with the veteran information about your employees.  Next we will ask you to map the information to standardized categories.",
  mapSexualOrientation:
    "Please upload a .csv file with the sexual orientation information about your employees.  Next we will ask you to map the information to standardized categories.",
  orgChart:
    "Please upload a .csv file containing information about the organization that each of your employees belongs to. Next you will select the specific column in the .csv file that contains the organizational information, and you will be able to drag and drop the organizations to form your Enterprise hierarchy.",
  mapGender:
    "Please upload a .csv file with the gender information about your employees.  Next we will ask you to map the information to standardized categories.",
  mapPositions:
    "Please upload a .csv file containing information about positions within your enterprise. Next, we will ask you to match relevant columns and map these positions to standardized occupational and job categories. If you don’t want to map positions now, you can skip the mapping and do it at a later time.",
  mapPerformance:
    "Please upload a .csv file with the performance ratings you use in your organization. Next, we will ask you to match relevant columns and map values to a standardized set of perfomance ratings. If you don’t want to map performance now, you can skip the mapping and do it at a later time.",
  mapSeparation:
    "Please upload a .csv file with your employee separation information. Next we will ask you to match the relevant columns and map your separation categories (e.g. voluntary and involuntary) to a standard set to allow calculation of KPIs and benchmarks.",
  mapEthnicity:
    "Please upload a .csv file with your employee ethnicity information.  Next we will ask you to map the information to standardized categories.",
  mapDisability:
    "Please upload a .csv file with your employee disability information.  Next we will ask you to map the information to standardized categories.",
};

export const reviewInstruction = {
  orgChart:
    "Please review your selections to confirm your organizational hierarchy.",
  mapGender:
    "Please review the selections you made before you finalise the mapping.",
  mapPositions:
    "Please review the selections you made before you finalise the mapping.",
  mapEthnicity:
    "Please review the selections you made before you finalise the mapping.",
  mapSexualOrientation:
    "Please review the selections you made before you finalise the mapping.",
  mapReligion:
    "Please review the selections you made before you finalise the mapping.",
  mapVeteran:
    "Please review the selections you made before you finalise the mapping.",
  mapPerformance:
    "Please review the selections you made before you finalise the mapping.",
  mapSeparation:
    "Please review the selections you made before you finalise the mapping. ",
  mapDisability:
    "Please review the selections you made before you finalise the mapping.",
};

// export const matchColumnsType = {
//     orgChart: 'Org Chart',
//     gender: 'Gender',
//     positions: 'Positions',
//     perfomance: 'Perfomance'
// }

export const mapType = {
  orgChart: "Org Chart",
  gender: "Gender",
  positions: "Positions",
  performance: "Perfomance",
  ethnicity: "Ethnicity",
  birthDate: "Age",
  sexualOrientation: "Sexual Orientation",
  disability: "Physical or Emotional Disabilities",
  religion: "Religion",
  separation: "Separation",
  uploadEmployeeDataCsv: "Employee CSV",
};

export const weeklyWinsInspirations = [
  "Quick Impact: Read an article about unconscious bias. Think about your biases.",
  "Quick Impact: Take 10 minutes and write down how you think those with different backgrounds from your own feel about your workplace.",
  "Quick Impact: Read an article about the business case for diversity and inclusion (hint: you can browse the Toolkit).",
  "Quick Impact: Think about the diversity of your team in comparison to the diversity of your client teams and/or customers.",
  "Quick Impact: Think about the words you use to describe people with different backgrounds. Notice any trends that you may need to address.",
  "Quick Impact: Approach a team member that you have talked to the least this month and ask about their work.",
  "Quick Impact: Ask someone on your team (or volunteer yourself) to mentor a team member with a different background.",
  "Quick Impact: Ask a team member who usually eats alone if they'd like to have lunch together.",
  "Quick Impact: Count how many times different people talk in your meetings, and notice if everyone is included in the conversation.",
  "Quick Impact: Notice if some people are interrupted in meetings, and take action as appropriate.",
  "Quick Impact: Notice if in meetings an idea presented by someone gets a lot more attention when presented later by someone else, and take action as appropriate.",
  'Quick Impact: Rotate "work/office keeping" tasks among all team members, like note taking, conference line/room set up, event/party planning etc.',
  "Quick Impact: Be transparent about your family/life obligations with your team.",
  "Quick Impact: Write a hand-written thank you note (instead of a text or an email) to a colleague for something they did.",
  "Quick Impact: Call a colleague (instead of texting or emailing) to thank them for something they did.",
  "Quick Impact: Congratulate a colleague that you don't typically interact with for something they did..",
  "Quick Impact: Think about past work events or get togethers, and ask yourself if you think they were held at venues that everyone could enjoy, including women and under-represented members of the team.",
  "Quick Impact: For an upcoming work event or get together, suggest a venue to the organizers (or select one, if you're the organizer) that everyone can enjoy, including women and under-represented members of the team.",
  "Quick Impact: Watch your use of the words 'You' and 'They.' Try to use 'We' instead, as often as possible.",
  "Quick Impact: Take 10 minutes and think of what you could do this week to make someone you work with feel more included.",
  "Quick Impact: As you're coming to work, walking to meetings, or visiting customers or suppliers, say hi to someone that you don't typically talk to, or have not met before, and ask how their week is going.",
  "Quick Impact: Remember the family/life obligations of your co-workers and take them into consideration for planning and assignment management.",
  "Quick Impact: Recognize a work or milestone anniversary of a diverse member of the team.",
  "Medium Impact: Attend unconscious bias training, or take an online unconscious bias test. Identify an area of your unconscious bias and take action to interrupt it.",
  "Medium Impact: Meet with a diverse team member and ask how they feel about your workplace. Listen, do not interrupt or defend.",
  "Medium Impact: Meet with a diverse group of team members and discuss the business case for diversity and inclusion.",
  "Medium Impact: Stop someone when they describe a woman, racial/ethnic minority or member of LGBT community in a derogatory way.",
  "Medium Impact: Publicly recognize a diverse team member for their efforts and highlight their results.",
  "Medium Impact: Have a mentoring or coaching meeting with a diverse member of your team.",
  "Medium Impact: Try to find a diverse group to have breaks or lunch with, at least 3x this week.",
  "Medium Impact: Lead or sponsor a diversity network or event.",
  "Medium Impact: Meet with senior or executive leadership and recommend an inclusive policy or practice change.",
  "Medium Impact: Actively solicit inputs for a business idea or regarding a solution from the diverse team members in the meeting.",
  "Medium Impact: Model the behavior by taking advantage of the work/life/family benefits offered by your organization.",
  "High Impact: Put in place a systemic way to mitigate a potential source of  unconscious bias - e.g. institute blind resumes.",
  "High Impact: Meet with a diverse group of employees and ask for their inputs to identify at least 2 actions to address their concerns regarding inclusion and belonging in your workplace.",
  "High Impact: Together with your team, generate a list of workplace practices that are more difficult for some of them; e.g. early morning meetings, scheduling major deliverables right after a holiday.",
  "High Impact: Discuss the type of team and customer events you organize, and specifically identify those that are inclusive -- i.e. considered enjoyable -- by all team members and customers.",
  'High Impact: "Sponsor" a diverse member of your team by communicating their accomplishments to a senior leader or executive.',
  "High Impact: Sponsor a diverse member of your team for a challenging, visible assignment and/or career advancement.",
  "High Impact: Meet with your managers and recruiters to review your job descriptions and posting, and adjust the language as needed to be more inclusive.",
  "High Impact: Meet with your managers and recruiters to review the interview process and questions, and adjust them as needed to be more inclusive. ",
  "High Impact: Meet with your managers and recruiters to review the process for selecting interviewers, and adjust it to be more inclusive.",
  "High Impact: Require that a diverse slate of candidates be presented for all management level positions.",
  "High Impact: Institute blind resumes (no names, diversity info, university info, or home address) for initial candidate screening.",
  "High Impact: Meet with your more diverse customers or vendors and ask what your organization can do to be more inclusive.",
  "High Impact: Take a chance on a diverse team member with high potential, and assign them to a visible, high-impact, high-risk/reward project or client.",
  "High Impact: Participate as a speaker in a diversity event or leadership training program.",
  "High Impact: Introduce a diverse team member/co-worker/customer/vendor to a senior executive or influential business contact.",
  "High Impact: Start a regular standing mentoring/coaching relationship with a member of your team with a different background from your own.",
];

export const employeeCollectionDatabaseColumns = [
  { value: "baseSalary", label: "Base Compensation" },
  { value: "promotionDate", label: "Promotion Date" },
  // {value : "applicationDate", label:"Application Date"},
  // {value : "interviewDate", label:"Interview Date"},
  { value: "offerDate", label: "Offer Date" },
  { value: "ethnicity", label: "Ethnicity/Race" },
  { value: "hireDate", label: "Hire Date" },
  { value: "separationDate", label: "Separation Date" },
  { value: "seniority", label: "Job Category" },
  { value: "birthDate", label: "Birth Date" },
  { value: "sexualOrientation", label: "Sexual Orientation" },
  { value: "performanceRating", label: "Performance Rating" },
  { value: "occupation", label: "Occupation" },
  { value: "gender", label: "Gender" },
  { value: "religion", label: "Religion" },
  { value: "employeeOfficePath", label: "Office" },
  { value: "compaRatio", label: "Compa Ratio" },
  { value: "location", label: "State" },
  { value: "veteran", label: "Veteran" },
  { value: "disability", label: "Physical or Emotional Disability" },
  { value: "separationReason", label: "Separation Type" },
];

//// Story templates, topics, etc \\\
var today = new Date(Date.now());
export const storyTemplates = [
  {
    name: "Story",
    _id: "template_personal_01",
    placeholder:
      "** TYPE HERE ** Have a story you would like to share with others that might be helpful? To notify others, use the “@” symbol before their name.",
    image: other,
    // color:"#FFCBC1",
    color: "#ffcbc16e",
    border: "1px solid #eea89b",
    // history:[{type:"image",item: other, date:today}]
  },
  {
    name: "Workplace Culture",
    _id: "template_workplace_culture_01",
    placeholder:
      "** TYPE HERE ** Have you had or observed an experience recently that relates to your workplace culture? To notify others, use the “@” symbol before their name.",
    image: groupAchievement,
    color: "#00b9f16e",
    // "#BCEDE4",
    border: "1px solid #00b0e6",
    history: [{ type: "image", item: workplaceCult, date: today }],
  },
  {
    name: "Actions",
    _id: "template_microaction_01",
    placeholder:
      "** TYPE HERE ** Have you noticed someone making a small effort to create a welcoming and supportive workplace, or have you done so yourself? Share your experience here to inspire others to do the same.",
    image: careerGrowth,
    // color:"#FFF0D7",
    color: "#EBF0DF",
    border: "1px solid #8cb52c",
    history: [
      { type: "name", item: "Micro-actions", date: today },
      { type: "image", item: microactions, date: today },
    ],
  },
  {
    name: "Sustainability",
    _id: "template_sustainability_01",
    placeholder:
      "** TYPE HERE ** Have any sustainability tools or ideas you would like to share ? To notify others, use the “@” symbol before their name.",
    image: sustainabilityImg,
    color: "#bcede466",
    border: "1px solid #03a98a66",
    // border:"#D5D6D8 1px solid",
  },
  {
    name: "Resources",
    _id: "template_resource_01",
    placeholder:
      "** TYPE HERE ** Have a video, podcast, article, or something else that you want to share? To notify others, use the “@” symbol before their name.",
    image: resource,
    color: "#fed6e56e",
    border: "1px solid #f157916e",
    // history:[{type:"image",item: other, date:today}]
  },
  {
    name: "Feedback",
    _id: "template_feedback_01",
    placeholder:
      "** TYPE HERE ** Looking to get feedback on an idea? To notify others, use the “@” symbol before their name.",
    image: feedback,
    color: "#DCD3FF",
    border: "1px solid #9b6dfd",
    // history:[{type:"image",item: other, date:today}]
  },
  {
    name: "More Thoughts",
    _id: "template_other_01",
    placeholder:
      "** TYPE HERE ** What would you like to talk about? To notify others, use the “@” symbol before their name.",
    image: ideaSuggestion,
    color: "#fcf4cf",
    // border:"#D5D6D8 1px solid",
    border: "1px solid #edd117",
    history: [{ type: "image", item: other, date: today }],
  },
];

export const wikimediaAuth =
  "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0MjE1ODRhZjk0ZGRiNTA2ZWUyMTdmODMxMGJmMjJhYyIsImp0aSI6IjUzZDc2MDliZTIwMzY0MDdiZDBiYjBjY2NhM2IxZjJhY2E1ODk0YzQ3M2M0N2U2NjNhMzE4ZGMzMTJkYWFhN2NiNjdiY2YwOTE4ZmZhYTc3IiwiaWF0IjoxNjk4Njk2Njk0LjM0MjQ2NiwibmJmIjoxNjk4Njk2Njk0LjM0MjQ2OSwiZXhwIjozMzI1NTYwNTQ5NC4zNDAyNTIsInN1YiI6Ijc0MTMxOTM2IiwiaXNzIjoiaHR0cHM6Ly9tZXRhLndpa2ltZWRpYS5vcmciLCJyYXRlbGltaXQiOnsicmVxdWVzdHNfcGVyX3VuaXQiOjUwMDAsInVuaXQiOiJIT1VSIn0sInNjb3BlcyI6WyJiYXNpYyJdfQ.Wvtj0ag5QzG0kXcPscRx7vcadxHL13aNRyYtWAuNNKCMvSBUwt0c0WKF-bww1pbSutGfwDt0HP5XtszeIkeXvJ2CAUjZXH_dwlo3_wjIXJhAbRSLjYq7oDSJIvGfMoC8IlAB3NAiSYh6v-7XAx2L72EtAIPvlKnolGZsja3TeDaF72k84eivrhG5AiYQ5Rtd8QU_m0lm4AQRl_s0FX75oFd-mJELku3oMHdL80Huy6Ex2HDaSn6k_-rro6iJ6Oj6butjMR8YqBZfxX8nCpMnUi10vnV4MeL32Iil-BAQnzJ5tYgM49arx_yqYYcD3W0EMxNwqK0K4q3aj93VL7n8XvZzz3BKo9yWhAuxSYAaafT36HmreWECN0MHeFyqr_J9Kc2DBLGOts9g3QRjfDHyQireQub6hgFMQzLVG38UlJbDEwA5xZm6EuTI1L7xYXcNRQefzVusPtfx8T4aSDTy0Qd14PZLdBshYVo-BTti1VW3WLX6JGIljAes9WfhJ9h4M8X5l19aqWk9xLr4bLKKebNaxm3map3qCIm9gav0kVCCdH5nxzN97Ab035X2SrtpdVmV6u7Q3Td8AAaf-r40Zip4LJCkoxsXIb6eo7B0X91Z5X0ROkxfD8Miw5hTAoIY0RNNN7pH5shALUfPe2WST603aTxxPfcG6Uj085ZFGKU";

export const triviaCategoryAPI = (category) => {
  let today = new Date();
  let year = today.getFullYear();
  let month = String(today.getMonth() + 1).padStart(2, "0");
  let day = String(today.getDate()).padStart(2, "0");

  //  return `https://api.wikimedia.org/core/v1/wikipedia/en/search/page?q=${category}&limit=10`

  return `https://api.wikimedia.org/feed/v1/wikipedia/en/featured/${year}/${month}/${day}`;

  //   fetch( url,
  //     {
  //         headers: {
  //             'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0MjE1ODRhZjk0ZGRiNTA2ZWUyMTdmODMxMGJmMjJhYyIsImp0aSI6IjUzZDc2MDliZTIwMzY0MDdiZDBiYjBjY2NhM2IxZjJhY2E1ODk0YzQ3M2M0N2U2NjNhMzE4ZGMzMTJkYWFhN2NiNjdiY2YwOTE4ZmZhYTc3IiwiaWF0IjoxNjk4Njk2Njk0LjM0MjQ2NiwibmJmIjoxNjk4Njk2Njk0LjM0MjQ2OSwiZXhwIjozMzI1NTYwNTQ5NC4zNDAyNTIsInN1YiI6Ijc0MTMxOTM2IiwiaXNzIjoiaHR0cHM6Ly9tZXRhLndpa2ltZWRpYS5vcmciLCJyYXRlbGltaXQiOnsicmVxdWVzdHNfcGVyX3VuaXQiOjUwMDAsInVuaXQiOiJIT1VSIn0sInNjb3BlcyI6WyJiYXNpYyJdfQ.Wvtj0ag5QzG0kXcPscRx7vcadxHL13aNRyYtWAuNNKCMvSBUwt0c0WKF-bww1pbSutGfwDt0HP5XtszeIkeXvJ2CAUjZXH_dwlo3_wjIXJhAbRSLjYq7oDSJIvGfMoC8IlAB3NAiSYh6v-7XAx2L72EtAIPvlKnolGZsja3TeDaF72k84eivrhG5AiYQ5Rtd8QU_m0lm4AQRl_s0FX75oFd-mJELku3oMHdL80Huy6Ex2HDaSn6k_-rro6iJ6Oj6butjMR8YqBZfxX8nCpMnUi10vnV4MeL32Iil-BAQnzJ5tYgM49arx_yqYYcD3W0EMxNwqK0K4q3aj93VL7n8XvZzz3BKo9yWhAuxSYAaafT36HmreWECN0MHeFyqr_J9Kc2DBLGOts9g3QRjfDHyQireQub6hgFMQzLVG38UlJbDEwA5xZm6EuTI1L7xYXcNRQefzVusPtfx8T4aSDTy0Qd14PZLdBshYVo-BTti1VW3WLX6JGIljAes9WfhJ9h4M8X5l19aqWk9xLr4bLKKebNaxm3map3qCIm9gav0kVCCdH5nxzN97Ab035X2SrtpdVmV6u7Q3Td8AAaf-r40Zip4LJCkoxsXIb6eo7B0X91Z5X0ROkxfD8Miw5hTAoIY0RNNN7pH5shALUfPe2WST603aTxxPfcG6Uj085ZFGKU',
  //             'Api-User-Agent': 'Trivvy(acqajar@gmail.com)'
  //         }
  //     }
  // );
};

/* Column headers on the Trivvy list pages. "Rate" renders on Surveys and
   Knowledge Checks, "Attention" on Surveys and Messaging — eight sites across
   three files (desktop + mobile header rows), so an inline copy would drift.
   Library has neither column and does not import this.

   Deliberately NOT used by the CSV exports: the "Response Rate" CSV column
   label stays as-is (TriviaList.jsx, TriviaKCSList.jsx), because renaming it
   changes a downloadable artifact's schema rather than a screen (TBV-853).
   There is no "Needs Attention" CSV column to keep. */
export const TRIVVY_LIST_COLUMN_LABELS = {
  RATE: "Rate",
  ATTENTION: "Attention",
};

export const triviaListCategories = [
  // {
  //   name: "Trending Trivvy",
  //   _id: "template_personal_01",
  //   placeholder:
  //     "** TYPE HERE ** Have a story you would like to share with others that might be helpful? To notify others, use the “@” symbol before their name.",
  //   image: other,
  //   // color:"#FFCBC1",
  //   color: "#ffcbc16e",
  //   border: "1px solid #eea89b",
  //   // history:[{type:"image",item: other, date:today}]
  // },
  {
    name: "Travel",
    _id: "template_workplace_culture_01",
    placeholder:
      "** TYPE HERE ** Have you had or observed an experience recently that relates to your workplace culture? To notify others, use the “@” symbol before their name.",
    image: groupAchievement,
    color: "#00b9f16e",
    // "#BCEDE4",
    border: "1px solid #00b0e6",
    history: [{ type: "image", item: workplaceCult, date: today }],
  },
  {
    name: "Culture",
    _id: "template_microaction_01",
    placeholder:
      "** TYPE HERE ** Have you seen someone take a small action in the workplace that was inclusive, or have you taken one yourself? Share your Micro-action here to help others take action too.",
    image: careerGrowth,
    // color:"#FFF0D7",
    color: "#EBF0DF",
    border: "1px solid #8cb52c",
    history: [
      { type: "name", item: "Micro-actions", date: today },
      { type: "image", item: microactions, date: today },
    ],
  },
  {
    name: "Health & Wellness",
    _id: "template_sustainability_01",
    placeholder:
      "** TYPE HERE ** Have any sustainability tools or ideas you would like to share ? To notify others, use the “@” symbol before their name.",
    image: sustainabilityImg,
    color: "#bcede466",
    border: "1px solid #03a98a66",
    // border:"#D5D6D8 1px solid",
  },
  {
    name: "Wonders of the World",
    _id: "template_resource_01",
    placeholder:
      "** TYPE HERE ** Have a video, podcast, article, or something else that you want to share? To notify others, use the “@” symbol before their name.",
    image: resource,
    color: "#fed6e56e",
    border: "1px solid #f157916e",
    // history:[{type:"image",item: other, date:today}]
  },
  // {
  //   name: "Awe-inspiring",
  //   _id: "template_feedback_01",
  //   placeholder:
  //     "** TYPE HERE ** Looking to get feedback on an idea? To notify others, use the “@” symbol before their name.",
  //   image: feedback,
  //   color: "#DCD3FF",
  //   border: "1px solid #9b6dfd",
  //   // history:[{type:"image",item: other, date:today}]
  // },
  // {
  //   name: "Random",
  //   _id: "template_other_01",
  //   placeholder:
  //     "** TYPE HERE ** What would you like to talk about? To notify others, use the “@” symbol before their name.",
  //   image: ideaSuggestion,
  //   color: "#fcf4cf",
  //   // border:"#D5D6D8 1px solid",
  //   border: "1px solid #edd117",
  //   history: [{ type: "image", item: other, date: today }],
  // },
];

export const storyReactions = [
  { name: "Like", _id: "reaction_like_01", image: like, color: "#de9c0d" },
  {
    name: "Celebrate",
    _id: "reaction_celebrate_01",
    image: celebrate,
    color: "#008000",
  },
  {
    name: "Curious",
    _id: "reaction_curious_01",
    image: curious,
    color: "#bc42bc",
  },
  {
    name: "Support",
    _id: "reaction_support_01",
    image: support,
    color: "#6d25e6",
  },
  {
    name: "Action",
    _id: "reaction_action_01",
    image: action,
    color: "#15a6aa",
  },
  { name: "Sad", _id: "reaction_sad_01", image: sad, color: "#e62599" },
  { name: "Thank", _id: "reaction_thanks_01", image: thank, color: "#0e5ddf" },
];

export const get_user_initials = (user) => {
  let firstName =
    user.firstName && user.firstName.length > 0 ? user.firstName : "N";
  let lastName =
    user.lastName && user.lastName.length > 0 ? user.lastName : "N";
  return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
};

export const get_reaction_image = (val) => {
  let selected = storyReactions.filter((x) => x._id === val)[0];
  return selected && selected.image;
};

// export const get_reaction_text = reaction =>{
//     let res = storyReactions.filter(e=>e._id == reaction._id)[0]
//     return ( <span className="story_reaction_modal_rname" style={{"color":`${res['color']}` }}> {res.name} </span>)
// }

export const applicantCollectionDatabaseColumns = [
  { value: "applicationDate", label: "Application Date" },
  { value: "interviewDate", label: "Interview Date" },
  { value: "offerDate", label: "Offer Date" },
  { value: "seniority", label: "Job Category" },
  { value: "ethnicity", label: "Ethnicity/Race" },
  { value: "occupation", label: "Occupation" },
  { value: "veteran", label: "Veteran" },
  { value: "religion", label: "Religion" },
  { value: "birthDate", label: "Birth Date" },
  { value: "sexualOrientation", label: "Sexual Orientation" },
  { value: "gender", label: "Gender" },
  { value: "applicantOfficePath", label: "Office" },
  { value: "disability", label: "Physical or Emotional Disability" },
  { value: "location", label: "State" },
];

export const genderOptions = [
  {
    id: "ALL",
    name: "All",
  },
  {
    id: "MALE",
    name: "Male",
  },
  {
    id: "FEMALE",
    name: "Female",
  },
  {
    id: "OTHER",
    name: "Other",
  },
  {
    id: "NON-BINARY",
    name: "Non-binary",
  },
  {
    id: "Prefer not to specify",
    name: "Prefer not to specify",
  },
];

export const getEmptyRecord = (label, order) => {
  return {
    label,
    order,
    enableGender: false,
    enableBirthDate: false,
    enableLocation: true,
    enableOccupation: false,
    enableSeniority: false,
    enableVeteran: false,
    enableSexualOrientation: false,
    sexualOrientation: null,
    enableReligion: false,
    enableDisability: false,
    religion: null,
    enableEthnicity: false,
    ethnicity: null,
    birthDate: null,
    disability: null,
    genderOptions: deepClone(genderOptions),
    gender: null,
    selectedLocation: { country: null, state: null },
    gender: null,
    occupation: null,
    veteran: null,
    seniority: null,
    performance: null,
    separation: null,
    selectedKPI: null,
    kpiType: "",
    selected: false,
  };
};

export const emptyKPIRecords = [
  getEmptyRecord("1st", 1),
  getEmptyRecord("2nd", 2),
  getEmptyRecord("3rd", 3),
];

function range(start, end) {
  return Array(end - start + 1)
    .fill()
    .map((_, idx) => getEmptyRecord(`${start + idx}`, start + idx));
}

export const getEmptyKPIRecords = (length) => range(1, length);

export const TEMP = [
  {
    text: "Does the organization currently have a documented talent management strategy?",
    value: "yes",
    kpi: "Strategy",
  },
  {
    text:
      "Does the organization currently have a documented process to implement the talent management strategy?",
    value: "yes",
    kpi: "Strategy",
  },
  {
    text: "Does the organization currently have a documented DEI strategy?",
    value: "yes",
    kpi: "Strategy",
  },
  {
    text:
      "Does the organization currently have a documented process to implement the DEI strategy?",
    value: "yes",
    kpi: "Strategy",
  },
  {
    text:
      "Does the organization currently have assigned staff responsible for DEI?",
    value: "no",
    kpi: "Infrastructure",
  },
  {
    text:
      "Does the organization currently have a Chief Diversity Officer (CDO) or an equivalent executive with the primary function of managing DEI?",
    value: "no",
    kpi: "Infrastructure",
  },
  {
    text:
      "Does the Chief Diversity Officer (CDO) or equivalent currently report to the CEO/President?",
    value: "yes",
    kpi: "Infrastructure",
  },
  {
    text:
      "Does the organization currently have an allocated annual budget for DEI?",
    value: "no",
    kpi: "Infrastructure",
  },
  {
    text:
      "Does the organization currently task and measure progress of executives and managers towards DEI goals?",
    value: "yes",
    kpi: "Accountability",
  },
  {
    text:
      "Does progress towards meeting DEI goals currently influence performance evaluation and compensation outcomes for executives and managers?",
    value: "yes",
    kpi: "Accountability",
  },
  {
    text:
      "Does the organization currently task and measure progress of supervisors/front-line managers towards DEI goals?",
    value: "no",
    kpi: "Accountability",
  },
  {
    text:
      "Does progress towards meeting DEI goals currently influence performance evaluation and compensation outcomes for supervisors/front-line managers?",
    value: "no",
    kpi: "Accountability",
  },
  {
    text:
      "Does the organization currently task and measure progress of all employees towards DEI goals?",
    value: "yes",
    kpi: "Accountability",
  },
  {
    text:
      "Does progress towards meeting DEI goals currently influence performance evaluation and compensation outcomes for all employees?",
    value: "no",
    kpi: "Accountability",
  },
  {
    text:
      "In the most recent 12 months, has the organization conducted audits of gender-based variations in pay?",
    value: "yes",
    kpi: "Accountability",
  },
  {
    text:
      "In the most recent 12 months, has the organization conducted and/or sponsored leadership programs specifically designed for women?",
    value: "yes",
    kpi: "Training & Development",
  },
  {
    text:
      "In the most recent 12 months, has the organization had a targeted mentorship program for women?",
    value: "no",
    kpi: "Training & Development",
  },
  {
    text:
      "In the most recent 12 months, has the organization developed career growth plans for women? ",
    value: "yes",
    kpi: "Training & Development",
  },
  {
    text:
      "In the most recent 12 months, has the organization conducted and/or sponsored DEI training for executives and managers?",
    value: "no",
    kpi: "Training & Development",
  },
  {
    text:
      "In the most recent 12 months, has the organization conducted and/or sponsored DEI training for supervisors/front-line managers?",
    value: "yes",
    kpi: "Training & Development",
  },
  {
    text:
      "In the most recent 12 months, has the organization trained managers on mitigating unconscious bias?",
    value: "yes",
    kpi: "Training & Development",
  },
];

// export const genderMapOptions = [
//     {value : 'FEMALE',label:'Female'},
//     {value : 'MALE',label:'Male'},
//     {value : 'OTHER',label:'Other'},
//     {value : 'ANDROGYNOUS',label:'Androgynous'},
//     {value : 'BIGENDER',label:'Bigender'},
//     {value : 'AGENDER',label:'Agender'},
// ]

export const genderMapOptions = genderOptions.map((e) => {
  let obj = { value: e.id, label: e.name };
  return obj;
});

// console.log(genderMapOptions)

export const separationMapOptions = [
  {
    value: "Voluntary",
    label: "Voluntary",
  },
  {
    value: "Involuntary",
    label: "Involuntary",
  },
];

export const getMappings = (kpiType, gender) => {
  // console.log('kpiType: ', kpiType)
  if (kpiType === "EMP_DATA_BASED") {
    return {
      gender: true,
      ethnicity: true,
      birthDate: true,
      religion: true,
      sexualOrientation: true,
      veteran: true,
      separation: true,
      disability: true,
      birthDate: true,
      occupation: true,
      seniority: true,
      kpiType: "EMP_DATA_BASED",
      activeGenders: genderOptions.map((e) => e.name),
    };
  } else {
    if (gender === "All") {
      return {
        gender: false,
        occupation: false,
        seniority: false,
        kpiType: "SURVEY_BASED",
        activeGenders: ["All"],
      };
    } else if (gender == "Female") {
      return {
        gender: false,
        occupation: false,
        seniority: false,
        kpiType: "SURVEY_BASED",
        activeGenders: ["Women / underrepresented groups"],
      };
    } else {
      return {
        gender: false,
        occupation: false,
        seniority: false,
        kpiType: "SURVEY_BASED",
        activeGenders: ["All"],
      };
    }
  }
};

export const kpisMapping = {
  "COMP-1": getMappings("EMP_DATA_BASED"),
  "COMP-2": getMappings("EMP_DATA_BASED"),
  "COMP-3": getMappings("EMP_DATA_BASED"),
  "GRO-1": getMappings("EMP_DATA_BASED"),
  "GRO-2": getMappings("SURVEY_BASED", "All"),
  "GRO-3": {
    gender: true,
    occupation: true,
    birthDate: true,
    ethnicity: true,
    veteran: true,
    sexualOrientation: true,
    religion: true,
    disability: true,
    seniority: true,
    performance: true,
    performanceKey: "Usually exceeds expectations",
    kpiType: "EMP_DATA_BASED",
    activeGenders: genderOptions.map((e) => e.name),
  },
  "GRO-4": {
    gender: true,
    occupation: true,
    birthDate: true,
    ethnicity: true,
    veteran: true,
    sexualOrientation: true,
    religion: true,
    disability: true,
    seniority: true,
    performance: true,
    performanceKey: "Usually meets expectations",
    kpiType: "EMP_DATA_BASED",
    activeGenders: genderOptions.map((e) => e.name),
  },
  "GRO-5": {
    gender: true,
    occupation: true,
    birthDate: true,
    ethnicity: true,
    veteran: true,
    sexualOrientation: true,
    religion: true,
    disability: true,
    seniority: true,
    performance: true,
    performanceKey: "Usually does not meet expectations",
    kpiType: "EMP_DATA_BASED",
    activeGenders: genderOptions.map((e) => e.name),
  },
  "GRO-6": getMappings("SURVEY_BASED", "Female"),
  "GRO-6a": getMappings("SURVEY_BASED", "All"),
  "GRO-7": getMappings("SURVEY_BASED", "Female"),
  "GRO-7a": getMappings("SURVEY_BASED", "All"),
  "GRO-8": getMappings("SURVEY_BASED", "Female"),
  "GRO-8a": getMappings("SURVEY_BASED", "All"),
  "GRO-9": getMappings("SURVEY_BASED", "Female"),
  "GRO-10": getMappings("SURVEY_BASED", "Female"),
  "GRO-11": getMappings("SURVEY_BASED", "Female"),
  "HRT-1": getMappings("EMP_DATA_BASED"),
  "HRT-2": getMappings("EMP_DATA_BASED"),
  "HRT-3": getMappings("SURVEY_BASED", "Female"),
  "HRT-4": getMappings("EMP_DATA_BASED"),
  "HRT-5": getMappings("EMP_DATA_BASED"),
  "HRT-6": {
    gender: true,
    occupation: true,
    birthDate: true,
    ethnicity: true,
    veteran: true,
    sexualOrientation: true,
    religion: true,
    disability: true,
    seniority: true,
    separation: true,
    kpiType: "EMP_DATA_BASED",
    separationKey: "Voluntary",
    activeGenders: genderOptions.map((e) => e.name),
  },
  "HRT-7": {
    gender: true,
    occupation: true,
    birthDate: true,
    ethnicity: true,
    veteran: true,
    sexualOrientation: true,
    religion: true,
    disability: true,
    seniority: true,
    separation: true,
    kpiType: "EMP_DATA_BASED",
    separationKey: "Involuntary",
    activeGenders: genderOptions.map((e) => e.name),
  },
  "HRT-8": getMappings("SURVEY_BASED", "All"),
  "HRT-8a": getMappings("SURVEY_BASED", "All"),
  "PRP-1": getMappings("SURVEY_BASED", "All"),
  "PRP-2": getMappings("SURVEY_BASED", "All"),
  "PRP-3": getMappings("SURVEY_BASED", "All"),
  "PRP-4": getMappings("SURVEY_BASED", "All"),
  "PRP-5": getMappings("SURVEY_BASED", "All"),
  "PRP-6": getMappings("SURVEY_BASED", "All"),
  "PRP-7": getMappings("SURVEY_BASED", "All"),
  "PRP-8": getMappings("SURVEY_BASED", "All"),
  "PRP-9": getMappings("SURVEY_BASED", "All"),
  "PRP-10": getMappings("SURVEY_BASED", "All"),
  "PRP-11": getMappings("SURVEY_BASED", "All"),
  "PRP-12": getMappings("SURVEY_BASED", "All"),
  "REP-1": getMappings("EMP_DATA_BASED"),
  "REP-2": getMappings("SURVEY_BASED", "Female"),
  "B&C-1": getMappings("SURVEY_BASED", "All"),
  "B&C-2": getMappings("SURVEY_BASED", "All"),
  "B&C-3": getMappings("SURVEY_BASED", "All"),
  "B&C-4": getMappings("SURVEY_BASED", "All"),
  "B&C-5": getMappings("SURVEY_BASED", "All"),
  "B&C-6": getMappings("SURVEY_BASED", "All"),
  "B&C-7": getMappings("SURVEY_BASED", "All"),
  "B&C-8": getMappings("SURVEY_BASED", "All"),
  "B&C-9": getMappings("SURVEY_BASED", "All"),
  "B&C-10": getMappings("SURVEY_BASED", "All"),
  // 'B&C-1': {
  //     kpiType: 'SURVEY_BASED'
  // },
  // 'B&C-2': {
  //     kpiType: 'SURVEY_BASED'
  // },
  // 'B&C-3': {
  //     kpiType: 'SURVEY_BASED'
  // },
  // 'B&C-4': {
  //     kpiType: 'SURVEY_BASED'
  // },
  // 'B&C-5': {
  //     kpiType: 'SURVEY_BASED'
  // },
  // 'B&C-6': {
  //     kpiType: 'SURVEY_BASED'
  // },
  // 'B&C-7': {
  //     kpiType: 'SURVEY_BASED'
  // },
  // 'B&C-8': {
  //     kpiType: 'SURVEY_BASED'
  // },
  // 'B&C-9': {
  //     kpiType: 'SURVEY_BASED'
  // },
  // 'B&C-10': {
  //     kpiType: 'SURVEY_BASED'
  // }
};

export const kpiBasedType = {
  empDataBased: "EMP_DATA_BASED",
  surveyBased: "SURVEY_BASED",
};

export const findNodeData = (hierarchy, node) => {
  let result,
    foundNode,
    found = false;
  let { officePath } = hierarchy;
  for (var x = 0; x < officePath.length; x++) {
    let path = officePath[x];
    if (path.officeKey === node.officeKey) {
      result = path;
    }
  }
  // console.log(hierarchy, result)

  result = { ...node, ...result };

  if (Array.isArray(hierarchy)) {
    const i = findIndex(hierarchy, (n) => n.officeKey === node.officeKey);
    if (i > -1) {
      found = true;
      foundNode = node[i];
    }
  } else {
    found = hierarchy.officeKey === node.officeKey;
    if (found) {
      foundNode = hierarchy;
    }
  }
  //   console.log(found)

  if (found) {
    return foundNode;
  } else {
    if (Array.isArray(hierarchy)) {
      for (let k = 0; k < hierarchy.length; k++) {
        if (hierarchy[k].children) {
          return this.findNodeData(hierarchy[k].children, node);
        }
      }
    } else {
      return this.findNodeData(hierarchy.children, node);
    }
  }

  return result;
};

export const findParentNode = (tree, node) => {
  const flat = getFlatDataFromTree({
    treeData: tree,
    getNodeKey: ({ node }) => node.officeKey,
    ignoreCollapsed: false,
  });

  let length = flat.length;
  let parent;
  // console.log(flat, node)
  for (var x = 0; x < length; x++) {
    if (flat[x].node.officeKey === node.officeKey) {
      parent = flat[x].parentNode;
    }
  }
  // let index;
  // console.log('parent--', parent)
  if (parent && (!parent.name || typeof parent.name === "undefined")) {
    parent.name = parent.title;
  }

  // parent.children.forEach((e,idx)=> {
  //     if(e.officeKey===node.officeKey){
  //        index=idx
  //     }
  // })
  // parent = {...parent}
  // parent.children.push(node);
  // parent.children[index]=node
  // console.log(parent)

  return parent;
};

export const selectOfficeCheck = (chart) => {
  // console.log(chart)
  if (chart && chart.selectedOffice && chart.selectedOffice.value) {
    return true;
  } else {
    return false;
  }
};

export const returnHierarchyGroup = (hierarchy, officeKey) => {
  const flat = getFlatDataFromTree({
    treeData: hierarchy,
    getNodeKey: ({ node }) => node.officeKey,
    ignoreCollapsed: false,
  });
  let length = flat.length;
  let i = 0;
  let result = [];
  for (i; i < length; i++) {
    //   console.log(flat[i])
    if (flat[i].path.indexOf(officeKey) > -1) {
      result.push(flat[i].node.officeKey);
    }
  }
  return result;
};

export const findOfficeChart = (office, flatHierarchy) => {
  // console.log(flatHierarchy)
  // console.log('inside---', flatHierarchy)
  // if(selectedOffice!='' && selectedOffice!==null && selectedOffice!=undefined){
  //   return flatHierarchy.find(el => el.value === selectedOffice.value)
  // }
  if (office) {
    // console.log(office)
    return flatHierarchy.find(
      (el) =>
        el.label === office.name ||
        (el.archivedOfficeNames &&
          el.archivedOfficeNames.indexOf(office.name) > -1)
    );
  } else {
    return "";
  }
};

export const findNodeinHierarchy = (tree, officeKey, office) => {
  // consider parsing the PATH field in the flattened hierarchy ~ similar to parsing by "#" to find all children
  // console.log('----')
  // console.log('offKey--', officeKey)
  const flatHierarchy = getFlatDataFromTree({
    treeData: tree,
    getNodeKey: ({ node }) => node.officeKey,
    ignoreCollapsed: false,
  });

  if (officeKey) {
    let result = flatHierarchy.filter((e) => e.node.officeKey === officeKey);
    // console.log('res---', result)
    return result.length > 0
      ? result[0].node
      : { title: "Office Removed", isRemoved: true };
  } else if (office) {
    // console.log('flat----',flatHierarchy)
    let result;
    let nodeFound = flatHierarchy.find(
      (el) =>
        el.node.title === office.name ||
        (el.archivedOfficeNames &&
          el.archivedOfficeNames.indexOf(office.name) > -1)
    );
    result =
      nodeFound !== undefined && nodeFound
        ? nodeFound.node
        : { title: "Office Removed", isRemoved: true };
    return result;
  }
};

export const drillDownHierarchy = (flat, officeNode) => {
  // console.log('flat---', flat)
  // let oNode = officeNode.officeKey!== undefined && officeNode.officeKey? officeNode: findOfficeChart(officeNode, '',flat)

  // console.log(oNode)
  // let officeKey = oNode.officeKey

  // // officeKey = !officeKey || officeKey==null || officeKey == undefined? findOfficeChart(officeNode, '',flat).officeKey :officeKey
  // console.log('key---', officeKey)

  let nodeMap = findNodeinHierarchy(flat, officeNode.officeKey, officeNode);
  officeNode = { ...officeNode, ...nodeMap };
  // console.log(nodeMap, '------onode------',officeNode)
  let parentName = officeNode.title ? officeNode.title : officeNode.name;
  let childArray = !officeNode.children
    ? officeNode.childArray
      ? officeNode.childArray
      : officeNode
    : officeNode.children;

  let length =
    typeof childArray != "undefined" && childArray.length
      ? childArray.length
      : 0;
  let i = 0;
  let officeData = [];

  for (i = 0; i < length; i++) {
    let child = childArray[i];
    let obj = {
      name: !child.name ? child.title : child.name,
      officeKey: child.officeKey,
      pathArray: findAllNodesInPath(flat, child.officeKey),
      path: child.path,
    };
    officeData.push(obj);
  }

  officeData.push({
    name: parentName,
    path: officeNode.path,
    pathArray: findAllNodesInPath(flat, officeNode.officeKey),
    officeKey: officeNode.officeKey,
    isParent: true,
  });

  officeData.initialOfficeKey = officeNode.officeKey;
  return officeData;
};

export const findAllNodesInPath = (tree, officeKey) => {
  const flat = getFlatDataFromTree({
    treeData: tree,
    getNodeKey: ({ node }) => node.officeKey,
    ignoreCollapsed: false,
  });
  let length = flat.length;
  let i = 0;
  let result = [];
  for (i; i < length; i++) {
    if (flat[i].path.indexOf(officeKey) > -1) {
      result.push(flat[i].node.officeKey);
    }
  }
  return result;
};

export const computeOfficeKey = (office, org) => {
  // let orgName = org.replace(/ /g,'').toLowerCase().replace(/\s+/g, '')
  let orgId = org._id;
  // console.log(office, org)
  let year = new Date(org.createdDate).getFullYear();
  let month = new Date(org.createdDate).getMonth() + 1;
  let day = new Date(org.createdDate).getDate();
  let date = `${month}${day}${year}`;
  // let result = [...office].reduce((acc, currVal)=> acc.concat(currVal.charCodeAt())) + 'date?' +Date.now() + "org?" + orgName
  let result =
    [...office].reduce((acc, currVal) => acc.concat(currVal.charCodeAt())) +
    "?" +
    orgId +
    "?" +
    Date.now() +
    "?" +
    Math.floor(Math.random() * 100) +
    1;

  // let result = [...office].reduce((acc, currVal)=> acc.concat(currVal.charCodeAt())) +  "?" + "5c421da6363d02090ea4b9aa" + "?"+ '762021'

  return result;
};

export const manualTempState = [
  {
    text:
      "What % of employees would say there are good career growth opportunities in the organization?",
    value: "20",
    kpi: "GRO-2",
    category: "Employee Lifecycle",
  },
  {
    text:
      "What % of ready-now succession candidates for managerial roles are female?",
    value: "10",
    kpi: "GRO-10",
    category: "Employee Lifecycle",
  },
  {
    text:
      "What is the average EBIT margin in %, over the last (rolling) 12 months?",
    value: "20",
    kpi: "B&C-1",
    category: "Business & Culture",
  },
  {
    text: "What is the average ROIC in %, over the last (rolling) 12 months?",
    value: "30",
    kpi: "B&C-3",
    category: "Business & Culture",
  },
  {
    text:
      "What % of employees would say the organization motivates them to go beyond what they would in a similar role elsewhere?",
    value: "10",
    kpi: "B&C-6",
    category: "Business & Culture",
  },
  {
    text: "Does the organization currently have a documented talent management strategy?",
    value: "yes",
    kpi: "PRP-1",
    category: "Processes & Policies",
  },
  {
    text:
      "Does the organization currently have a documented process to implement the talent management strategy?",
    value: "yes",
    kpi: "PRP-1",
    category: "Processes & Policies",
  },
  {
    text: "Does the organization currently have a documented DEI strategy?",
    value: "no",
    kpi: "PRP-1",
    category: "Processes & Policies",
  },
  {
    text:
      "Does the organization currently have a documented process to implement the DEI strategy?",
    value: "yes",
    kpi: "PRP-1",
    category: "Processes & Policies",
  },
  {
    text:
      "What is the minimum fully paid maternity leave currently available to employees?",
    value: "1-4 weeks",
    kpi: "PRP-5",
    category: "Processes & Policies",
  },
  {
    text:
      "What is the minimum fully paid paternity leave currently available to employees?",
    value: "1-4 weeks",
    kpi: "PRP-5",
    category: "Processes & Policies",
  },
  {
    text:
      "Does the organization currently use a specific, defined recruiting strategy to increase women hires?",
    value: "yes",
    kpi: "PRP-10",
    category: "Processes & Policies",
  },
  {
    text:
      "Does the organization currently leverage DEI focused talent sources such as events, recruiting firms, Job Boards?",
    value: "yes",
    kpi: "PRP-10",
    category: "Processes & Policies",
  },
  {
    text:
      "Does the organization currently require a gender-diverse slate of candidates for management and executive roles?",
    value: "yes",
    kpi: "PRP-10",
    category: "Processes & Policies",
  },
  {
    text:
      "Does the organization currently require a gender-diverse slate of interviewers for management and executive roles?",
    value: "yes",
    kpi: "PRP-10",
    category: "Processes & Policies",
  },
  {
    text:
      "Does the organization currently have a program for recruiting women looking to transition back to the workforce after taking a career break?",
    value: "yes",
    kpi: "PRP-10",
    category: "Processes & Policies",
  },
  {
    text: "What % of members of the Board of Directors are female?",
    value: "7",
    kpi: "REP-2",
    category: "Board",
  },
];

export const formatDate = (date) => {
  return moment.utc(date).format("YYYY-MM-DD");
};

// const flat = getFlatDataFromTree({
//     treeData : oldH,
//     getNodeKey: ({ node }) => node.id,
//     ignoreCollapsed: false
//   })

//   let tempHierarchy = filter(flat,(o) => o != 'undefined').map((office,i) => {
//     const o = {...office, ...office.node}
//     // o.id = computeOfficeKey(office.node.title, this.props.user.profile.organizationId)
//     // o.node.id  = computeOfficeKey(office.node.title, this.props.user.profile.organizationId)
//     o.node.officeKey = computeOfficeKey(office.node.title, this.props.user.profile.organizationId)
//     o.officeKey = computeOfficeKey(office.node.title, this.props.user.profile.organizationId)
//     o.title = office.node.title;
//     // o.node.parent = office
//     o.subtitle = '';
//     // o.node.children = [];
//     return o;
//   });

//   let officeHierarchy =  getTreeFromFlatData({
//     flatData: tempHierarchy.map(e=> {
//       return {
//         ...e,
//         officeKey: e.officeKey,
//         // id: e.officeKey
//       }
//     }),
//     getKey: ( node ) => node.officeKey,
//     getParentKey: ( node ) => node.parentNode,
//     rootKey: null
//   })

const bad_words_array = [
  "ahole",
  "anus",
  "ash0le",
  "ash0les",
  "suck",
  "shit",
  "asholes",
  "ass",
  "Ass Monkey",
  "Assface",
  "assh0le",
  "assh0lez",
  "asshole",
  "assholes",
  "assholz",
  "asswipe",
  "azzhole",
  "bassterds",
  "bastard",
  "bastards",
  "bastardz",
  "basterds",
  "basterdz",
  "Biatch",
  "bitch",
  "bitches",
  "Blow Job",
  "boffing",
  "butthole",
  "buttwipe",
  "c0ck",
  "c0cks",
  "c0k",
  "Carpet Muncher",
  "cawk",
  "cawks",
  "Clit",
  "cnts",
  "cntz",
  "cock",
  "cockhead",
  "cock-head",
  "cocks",
  "CockSucker",
  "cock-sucker",
  "crap",
  "cum",
  "cunt",
  "cunts",
  "cuntz",
  "dick",
  "dild0",
  "dild0s",
  "dildo",
  "dildos",
  "dilld0",
  "dilld0s",
  "dominatricks",
  "dominatrics",
  "dominatrix",
  "dyke",
  "enema",
  "f u c k",
  "f u c k e r",
  "fag",
  "fag1t",
  "faget",
  "fagg1t",
  "faggit",
  "faggot",
  "fagg0t",
  "fagit",
  "fags",
  "fagz",
  "faig",
  "faigs",
  "fart",
  "flipping the bird",
  "fuck",
  "fucker",
  "fuckin",
  "fucking",
  "fucks",
  "Fudge Packer",
  "fuk",
  "Fukah",
  "Fuken",
  "fuker",
  "Fukin",
  "Fukk",
  "Fukkah",
  "Fukken",
  "Fukker",
  "Fukkin",
  "g00k",
  "gayboy",
  "gaygirl",
  "God-damned",
  "h00r",
  "h0ar",
  "h0re",
  // "hells",
  "hoar",
  "hoor",
  "hoore",
  "jackoff",
  "jap",
  "japs",
  "jerk-off",
  "jisim",
  "jiss",
  "jizm",
  "jizz",
  "knob",
  "knobs",
  "knobz",
  "kunt",
  "kunts",
  "kuntz",
  "Lezzian",
  "Lipshits",
  "Lipshitz",
  "masochist",
  "masokist",
  "massterbait",
  "masstrbait",
  "masstrbate",
  "masterbaiter",
  "masterbate",
  "masterbates",
  "Motha Fucker",
  "Motha Fuker",
  "Motha Fukkah",
  "Motha Fukker",
  "Mother Fucker",
  "Mother Fukah",
  "Mother Fuker",
  "Mother Fukkah",
  "Mother Fukker",
  "mother-fucker",
  "Mutha Fucker",
  "Mutha Fukah",
  "Mutha Fuker",
  "Mutha Fukkah",
  "Mutha Fukker",
  "n1gr",
  "nastt",
  "nigger;",
  "nigur;",
  "niiger;",
  "niigr;",
  "orafis",
  "orgasim;",
  "orgasm",
  "orgasum",
  "oriface",
  "orifice",
  "orifiss",
  "packi",
  "packie",
  "packy",
  "paki",
  "pakie",
  "paky",
  "pecker",
  "peeenus",
  "peeenusss",
  "peenus",
  "peinus",
  "pen1s",
  "penas",
  "penis",
  "penis-breath",
  "penus",
  "penuus",
  "Phuc",
  "Phuck",
  "Phuk",
  "Phuker",
  "Phukker",
  "polac",
  "polack",
  "polak",
  "Poonani",
  "pr1c",
  "pr1ck",
  "pr1k",
  "pusse",
  "pussee",
  "pussy",
  "puuke",
  "puuker",
  "qweers",
  "qweerz",
  "qweir",
  "recktum",
  "rectum",
  "retard",
  "sadist",
  "scank",
  "schlong",
  "screwing",
  "semen",
  "sexy",
  "Sh!t",
  "sh1t",
  "sh1ter",
  "sh1ts",
  "sh1tter",
  "sh1tz",
  "shit",
  "shits",
  "shitter",
  "Shitty",
  "Shity",
  "shitz",
  "Shyt",
  "Shyte",
  "Shytty",
  "Shyty",
  "skanck",
  "skank",
  "skankee",
  "skankey",
  "skanks",
  "Skanky",
  "slag",
  "slut",
  "sluts",
  "Slutty",
  "slutz",
  "son-of-a-bitch",
  "tit",
  "turd",
  "va1jina",
  "vag1na",
  "vagiina",
  "vagina",
  "vaj1na",
  "vajina",
  "vullva",
  "vulva",
  "w0p",
  "wh00r",
  "wh0re",
  "whore",
  "xrated",
  "xxx",
  "b!+ch",
  "bitch",
  "blowjob",
  "clit",
  "arschloch",
  "fuck",
  "shit",
  "ass",
  "asshole",
  "b!tch",
  "b17ch",
  "b1tch",
  "bastard",
  "bi+ch",
  "boiolas",
  "buceta",
  "c0ck",
  "cawk",
  "chink",
  "cipa",
  "clits",
  "cock",
  "cum",
  "cunt",
  "dildo",
  "dirsa",
  "ejakulate",
  "fatass",
  "fcuk",
  "fuk",
  "fux0r",
  "hoer",
  "hore",
  "jism",
  "kawk",
  "l3itch",
  "l3i+ch",
  "masturbate",
  "masterbat",
  "masterbat3",
  "motherfucker",
  "s.o.b.",
  "mofo",
  "nigga",
  "nigger",
  "nutsack",
  "phuck",
  "pimpis",
  "pusse",
  "pussy",
  "scrotum",
  "sh!t",
  "shemale",
  "shi+",
  "sh!+",
  "slut",
  "smut",
  "teets",
  "tits",
  "boobs",
  "b00bs",
  "teez",
  "testical",
  "testicle",
  "titt",
  "w00se",
  "jackoff",
  "wank",
  "whoar",
  "whore",
  "damn",
  "dyke",
  "fuck",
  "shit",
  "@$$",
  "amcik",
  "andskota",
  "arse",
  "assrammer",
  "ayir",
  "bi7ch",
  "bitch",
  "bollock",
  "breasts",
  "butt-pirate",
  "cabron",
  "cazzo",
  "chraa",
  "chuj",
  "Cock",
  "cunt",
  "d4mn",
  "daygo",
  "dego",
  "dick",
  "dike",
  "dupa",
  "dziwka",
  "ejackulate",
  "Ekrem",
  "Ekto",
  "enculer",
  "faen",
  "fag",
  "fanculo",
  "fanny",
  "feces",
  "feg",
  "Felcher",
  "ficken",
  "fitt",
  "Flikker",
  "foreskin",
  "Fotze",
  "Fu(",
  "fuk",
  "futkretzn",
  "gook",
  "guiena",
  "h0r",
  // "h4x0r",
  // "hell",
  "helvete",
  "hoer",
  "honkey",
  "Huevon",
  "hui",
  "injun",
  "jizz",
  "kanker",
  "kike",
  "klootzak",
  "kraut",
  "knulle",
  "kuk",
  "kuksuger",
  "Kurac",
  "kurwa",
  "kusi",
  "kyrpa",
  "lesbo",
  "mamhoon",
  "masturbat",
  "merd",
  "mibun",
  "monkleigh",
  "mouliewop",
  "muie",
  "mulkku",
  "muschi",
  "nepesaurio",
  "nigger",
  "orospu",
  "paska",
  "perse",
  "picka",
  "pierdol",
  "pillu",
  "pimmel",
  "piss",
  "pizda",
  "poontsee",
  "poop",
  "porn",
  "p0rn",
  "pr0n",
  "preteen",
  "pula",
  "pule",
  "puta",
  "puto",
  "qahbeh",
  "queef",
  "rautenberg",
  "schaffer",
  "scheiss",
  "schlampe",
  "schmuck",
  "screw",
  "sh!t",
  "sharmuta",
  "sharmute",
  "shipal",
  "shiz",
  "skribz",
  "skurwysyn",
  "sphencter",
  "spic",
  "spierdalaj",
  "splooge",
  "b00b",
  "testicle",
  "titt",
  "twat",
  "vittu",
  "wank",
  "wetback",
  "wichser",
  "wop",
  "yed",
  "zabourah",
];

const regMatchFilter = new RegExp(
  "\\b(" +
    bad_words_array.join("|").replace(/[\\[.+*?(){^$]/g, "\\$&") +
    ")\\b",
  "gi"
);

export const wordFilter = (str) => {
  return str.match(regMatchFilter) || [];
};

export const DEFAULT_GROUP_METRICS_DATA = [
  {
    groupName: "Group A",
    createdAt: new Date(),
    createdBy: {
      _id: "5c5052f0a9e716090e3263c2",
      mobileNumber: "",
      countryCode: "",
      isPasswordChanged: true,
      orgAdmin: false,
      isProfileDetailsUpdated: true,
      isDeleted: false,
      hasLoggedIn: true,
      hideIntro: false,
      email: "newundefinednewundefinedemad.attalla@amgeneral.com_test_prod",
      firstName: "Emad",
      lastName: "Attalla",
      password: "$2a$10$9rAU4lKTRZkncBT2T.z/ee1k1uvfR8tRibTeSe.eeM8/5PpsyMRN.",
      status: "ACTIVE",
      officeId: "5c5052f018a4f7b2be684e76",
      organizationId: "5c421da6363d02090ea4b9aa",
      officeHierarchyPath:
        "069701-Office Of the President#069703-Office Of the President#069707-Office Of the President",
      role: "Admin",
      createDate: "2019-01-29T13:19:44.973Z",
      favoriteTools: [],
      favoriteGraphs: [],
      tokens: [
        {
          _id: "5cf956466e4c494f8c9409b3",
          access: "auth",
          token:
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1YzUwNTJmMGE5ZTcxNjA5MGUzMjYzYzIiLCJhY2Nlc3MiOiJhdXRoIiwiaWF0IjoxNTU5ODQ0NDIyfQ.9LXiMcK8QTcnv5ATCx_-GNQO9wEzloZTp9p14g9KxIU",
        },
      ],
      __v: 8,
      dIRole: "",
      lastUpdate: {
        firstName: "Emad",
        lastName: "Attalla",
        title: "Director Engineering",
        dIRole: "",
        profilePic:
          "https://prod-oo-app-attachment.s3.us-east-2.amazonaws.com/users/5c5052f0a9e716090e3263c2-lg?timestamp=1551295011646",
        updatedBy: "emad.attalla@amgeneral.com",
      },
      profilePic:
        "https://prod-oo-app-attachment.s3.us-east-2.amazonaws.com/users/5c5052f0a9e716090e3263c2-lg?timestamp=1551295011646",
      title: "Director Engineering",
      groups: [],
    },
    noOfMembers: 6,
    noOfEvents: 8,
    noOfEventsRegistrants: 9,
    demographicsOfRegistants: "Type",
    noOfActions: 90,
    noOfKPIs: 8,
  },
  {
    groupName: "Group B",
    createdAt: new Date(),
    createdBy: {
      _id: "5c5052f0a9e716090e3263c2",
      mobileNumber: "",
      countryCode: "",
      isPasswordChanged: true,
      orgAdmin: false,
      isProfileDetailsUpdated: true,
      isDeleted: false,
      hasLoggedIn: true,
      hideIntro: false,
      email: "newundefinednewundefinedemad.attalla@amgeneral.com_test_prod",
      firstName: "Emad",
      lastName: "Attalla",
      password: "$2a$10$9rAU4lKTRZkncBT2T.z/ee1k1uvfR8tRibTeSe.eeM8/5PpsyMRN.",
      status: "ACTIVE",
      officeId: "5c5052f018a4f7b2be684e76",
      organizationId: "5c421da6363d02090ea4b9aa",
      officeHierarchyPath:
        "069701-Office Of the President#069703-Office Of the President#069707-Office Of the President",
      role: "Admin",
      createDate: "2019-01-29T13:19:44.973Z",
      favoriteTools: [],
      favoriteGraphs: [],
      tokens: [
        {
          _id: "5cf956466e4c494f8c9409b3",
          access: "auth",
          token:
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1YzUwNTJmMGE5ZTcxNjA5MGUzMjYzYzIiLCJhY2Nlc3MiOiJhdXRoIiwiaWF0IjoxNTU5ODQ0NDIyfQ.9LXiMcK8QTcnv5ATCx_-GNQO9wEzloZTp9p14g9KxIU",
        },
      ],
      __v: 8,
      dIRole: "",
      lastUpdate: {
        firstName: "Emad",
        lastName: "Attalla",
        title: "Director Engineering",
        dIRole: "",
        profilePic:
          "https://prod-oo-app-attachment.s3.us-east-2.amazonaws.com/users/5c5052f0a9e716090e3263c2-lg?timestamp=1551295011646",
        updatedBy: "emad.attalla@amgeneral.com",
      },
      profilePic:
        "https://prod-oo-app-attachment.s3.us-east-2.amazonaws.com/users/5c5052f0a9e716090e3263c2-lg?timestamp=1551295011646",
      title: "Director Engineering",
      groups: [],
    },
    noOfMembers: 6,
    noOfEvents: 8,
    noOfEventsRegistrants: 9,
    demographicsOfRegistants: "Type",
    noOfActions: 90,
    noOfKPIs: 8,
  },
  {
    groupName: "Group C",
    createdAt: new Date(),
    createdBy: {
      _id: "5c5052f0a9e716090e3263c2",
      mobileNumber: "",
      countryCode: "",
      isPasswordChanged: true,
      orgAdmin: false,
      isProfileDetailsUpdated: true,
      isDeleted: false,
      hasLoggedIn: true,
      hideIntro: false,
      email: "newundefinednewundefinedemad.attalla@amgeneral.com_test_prod",
      firstName: "Emad",
      lastName: "Attalla",
      password: "$2a$10$9rAU4lKTRZkncBT2T.z/ee1k1uvfR8tRibTeSe.eeM8/5PpsyMRN.",
      status: "ACTIVE",
      officeId: "5c5052f018a4f7b2be684e76",
      organizationId: "5c421da6363d02090ea4b9aa",
      officeHierarchyPath:
        "069701-Office Of the President#069703-Office Of the President#069707-Office Of the President",
      role: "Admin",
      createDate: "2019-01-29T13:19:44.973Z",
      favoriteTools: [],
      favoriteGraphs: [],
      tokens: [
        {
          _id: "5cf956466e4c494f8c9409b3",
          access: "auth",
          token:
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1YzUwNTJmMGE5ZTcxNjA5MGUzMjYzYzIiLCJhY2Nlc3MiOiJhdXRoIiwiaWF0IjoxNTU5ODQ0NDIyfQ.9LXiMcK8QTcnv5ATCx_-GNQO9wEzloZTp9p14g9KxIU",
        },
      ],
      __v: 8,
      dIRole: "",
      lastUpdate: {
        firstName: "Emad",
        lastName: "Attalla",
        title: "Director Engineering",
        dIRole: "",
        profilePic:
          "https://prod-oo-app-attachment.s3.us-east-2.amazonaws.com/users/5c5052f0a9e716090e3263c2-lg?timestamp=1551295011646",
        updatedBy: "emad.attalla@amgeneral.com",
      },
      profilePic:
        "https://prod-oo-app-attachment.s3.us-east-2.amazonaws.com/users/5c5052f0a9e716090e3263c2-lg?timestamp=1551295011646",
      title: "Director Engineering",
      groups: [],
    },
    noOfMembers: 6,
    noOfEvents: 8,
    noOfEventsRegistrants: 9,
    demographicsOfRegistants: "Type",
    noOfActions: 90,
    noOfKPIs: 8,
  },
];

export const privacyMap = {
  0: "Private",
  1: "Public",
  2:"Linked"
};

export const chatQuerySearchTypes = {
  SCRAPE: "SCRAPE",
  AI_SINGLE_QUESTION: "AI_SINGLE_QUESTION",
  AI_TWO_PARTS_QUESTION: "AI_TWO_PARTS_QUESTION",
};

export const createHTMLparagraphs = (input) => {
  let finalString;
  var sentencePattern = /[.!?]\s?/;
  var sentences = input.split(sentencePattern);
  sentences = sentences.filter(function(sentence) {
    return sentence.length > 0;
  });
  let paragraphs = [];

  if (sentences && sentences.length > 4) {
    for (let i = 0; i < sentences.length; i += 4) {
      const group = sentences.slice(i, i + 4);
      let paragraph = "<p>" + group.join(" ") + ". </p>";
      paragraphs.push(paragraph);
    }

    finalString = paragraphs.join("");
  } else {
    finalString = input;
  }
};

export const standardizeSearchQuery = (query) => {
  const qry = query.toLowerCase();
  if (qry.includes("table") || qry.includes("tabular") || qry.includes("in")) {
    return query
      .replace("table", "an HTML table display")
      .replace("Table", "an HTML table display")
      .replace("Tabular", "an HTML table display")
      .replace("tabular", "an HTML table display")
      .replace("Table display", "an HTML table display")
      .replace("table display", "an HTML table display")
      .replace(`"table display"`, "an HTML table display")
      .replace(
        "word cloud",
        "text based word cloud with the frequency of the words"
      )
      .replace(
        "Word cloud",
        "text based word cloud with the frequency of the words"
      )
      .replace(
        "Word Cloud",
        "text based word cloud with the frequency of the words"
      )
      .replace(`"Table display"`, "an HTML table display");
  }
  if (qry.includes("list")) {
    return query
      .replace("list", "HTML unordered list")
      .replace("ordered list", "HTML ordered list")
      .replace(
        "word cloud",
        "text based word cloud with the frequency of the words"
      )
      .replace(
        "Word cloud",
        "text based word cloud with the frequency of the words"
      )
      .replace(
        "Word Cloud",
        "text based word cloud with the frequency of the words"
      )
      .replace("numbered list", "HTML ordered list");
  }

  query = query
    .replace(
      "word cloud",
      "text based word cloud with the frequency of the words"
    )
    .replace(
      "Word cloud",
      "text based word cloud with the frequency of the words"
    )
    .replace(
      "Word Cloud",
      "text based word cloud with the frequency of the words"
    );

  return query;
};

export const standardizedNLPQuery = (query) => {
  let qry = query;
  // .toLowerCase();
  console.log("query --- ", query);
  if (qry.includes("table") || qry.includes("tabular") || qry.includes("in")) {
    qry = qry
      // .replace("table", "")
      // .replace("Table", "")
      // .replace("Tabular", "")
      // .replace("tabular", "")
      // .replace("Table display", "")
      // .replace("table display", "")
      // .replace(`"table display"`, "")
      // .replace(`"Table display"`, "")
      // .replace(new RegExp('table display', "gi"), '')
      .replace(/as a table display/gi, "")
      .replace(/as a table display/gi, "")
      .replace(/as a table/gi, "")
      .replace(/a table/gi, "")
      .replace(/table/gi, "");
    // .replace(new RegExp('as a table display', "gi"), '')
    // .replace(new RegExp('as a table', "gi"), '')
  }
  if (qry.includes("list")) {
    qry = query
      .replace("list", "")
      .replace("ordered list", "")
      .replace("numbered list", "")
      .replace(/list/gi, "")
      .replace(/ordered list/gi, "")
      .replace(/numbered list/gi, "");
  }

  let res = qry
    .replace(/<("[^"]*"|'[^']*'|[^'">])*>/gi, "")
    .replace(/(<([^>]+)>)/gi, "")
    .replace(/\s+/g, " ")
    .replace(/^\s+|\s+$/g, "");
  console.log("qry --- > ", qry);

  return res;
};

export const getCompFuncByString = (str) => {
  if (str === "BenchMarkDetailsModal") {
    return BenchMarkDetailsModal;
  }
};

const removeTokens = (array, count) => {
  let removedCount = 0;

  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    const tokensRemaining = count - removedCount;

    const totalCharsLength = element.content.length;
    const totalTokens = Math.ceil(totalCharsLength / 4);

    if (tokensRemaining >= totalTokens) {
      removedCount = removedCount + totalTokens;
      element.content = "";
    } else {
      removedCount = removedCount + tokensRemaining;
      element.content = element.content.substring(
        0,
        totalCharsLength - tokensRemaining
      );
    }

    if (removedCount >= count) {
      break;
    }
  }

  const arr = array.filter((x) => !isEmpty(x.content));

  console.log(arr, removedCount);

  return arr;
};

export const reduceDaniHistoryMessages = (messages, question) => {
  const questionTokens = Math.ceil(question.length / 4);
  if (messages.length > 0) {
    const lastMessageTotalTokens =
      messages[messages.length - 1].usage.total_tokens;
    if (lastMessageTotalTokens + questionTokens >= 3600) {
      if (lastMessageTotalTokens + questionTokens >= 4100) {
        console.log(lastMessageTotalTokens, questionTokens);
        const totalMax = lastMessageTotalTokens + questionTokens;
        const idealThreshhold = 4096 - Math.floor(questionTokens * 0.5);
        const val = totalMax - idealThreshhold;
        console.log(val);
        return removeTokens(messages, Math.abs(totalMax - val));
      }
      return removeTokens(messages, 1000);
    }
  }

  return messages;
};
export const SHOW_MORE_TYPES = [
  {
    label: "Show more",
    value: "show_more",
  },
  // {
  //   label: "Clarify",
  //   value: "clarify",
  // },
  {
    label: "Examples",
    value: "exemplify",
  },
  // {
  //   label: "Expand",
  //   value: "expand",
  // },
  {
    label: "Explain",
    value: "explain",
  },
  // {
  //   label: "Rewrite",
  //   value: "rewrite",
  // },
  // { label: "Shorten", value: "shorten" },

  // { label: "Shorten", value: "shorten" },

  // { label: "Provide links to websites/urls", value: "show_links" },
  { label: "Summarize", value: "summarize" },
];

const appEnvHost = window.location.hostname;

export const serverAuthBaseUrl = () => {
  const hostname = appEnvHost;
  let localBool = hostname.indexOf("localhost") > -1;
  let devBool = hostname.indexOf("devportal") > -1;
  let qaBool = hostname.indexOf("qaportal") > -1;
  let portalBool = hostname.indexOf("portal.o") > -1;

  let baseUrl;

  // https://e0b6-103-51-154-255.ngrok-free.app/
  const ngrok_url =
    "https://0d0a-2402-e280-3e21-af7-286b-65cf-b5b3-ff1.ngrok-free.app/";

  if (localBool) {
    baseUrl = ngrok_url;
  } else {
    baseUrl = "https://devapi.ouroffice.io/";
  }
  // else if (qaBool) {
  //   baseUrl = "https://qaapi.ouroffice.io/";
  // } else if (portalBool) {
  //   baseUrl = "https://api.ouroffice.io/";
  // }

  return baseUrl;
};

export const xtract = async (url, pass) => {
  let alltext = "";
  try {
    let pdf;

    pdf = await window.spp.getDocument(url).promise; // Get the PDF document without password
    console.log("pdf ---- ", pdf);
    let pages = pdf.numPages; // Get the total number of pages in the PDF
    for (let i = 1; i <= pages; i++) {
      let page = await pdf.getPage(i); // Get the page object for each page
      let txt = await page.getTextContent(); // Get the text content of the page
      console.log("txt ---- ", txt);
      let text = txt.items.map((s) => s.str).join(" "); // Concatenate the text items into a single string
      // alltext += "\n " + text; // Add the extracted text to the array
      alltext += text; // Add the extracted text to the array
    }

    return alltext;
  } catch (err) {
    console.log(err.message);
  }
};

export const getMessageTime = (time) => {
  const today = moment();
  const chatTime = moment(time);
  const diff = today.diff(chatTime, "days");
  if (diff < 1) {
    return moment(chatTime).format("hh:mm A");
  } else if (diff >= 1 && diff < 7) {
    return moment(chatTime).format("dddd");
  } else {
    if (diff > 365) {
      const num = Math.floor(diff / 365);
      return num === 1 ? `${num} Year` : `${num} Years`;
    } else if (diff > 30) {
      const num = Math.floor(diff / 30);
      return num === 1 ? `${num} Month` : `${num} Months`;
    } else {
      const num = Math.floor(diff / 7);
      return num === 1 ? `${num} week` : `${num} Weeks`;
    }
  }
};

export const limitTokenizeText = (text) => {
  const maxTokens = 2500;

  const totalCharsAllowed = maxTokens * 4;
  console.log("---------IN FUNCTION ----------", text.length, text);
  return text.substring(0, totalCharsAllowed);
};

export const validateSlackUrl = (url) => {
  // const pattern = /^https:\/\/[a-zA-Z0-9-]+\.slack\.com\/client\/[a-zA-Z0-9-]+$/;
  // return pattern.test(url);
  if (url) {
    return true;
  } else {
    return false;
  }
};

export const constructGroupLinkedUsersText = (item) => {
  if (item.linkedAnonymously) {
    return "Linked by Anonymous User";
  } else if (item.linkedByUser && !item.linkedAnonymously) {
    return item.linkedByUser.firstName || item.linkedByUser.lastName
      ? `Linked by ${item.linkedByUser.firstName || ""} ${item.linkedByUser
          .lastName || ""}`
      : "";
  } else {
    return "";
  }
};

export const MAX_DISTANCE_OPTIONS = [
  {
    label: "Any distance",
    value: "any",
  },
  {
    label: "2 Miles",
    value: 2,
  },
  {
    label: "5 Miles",
    value: 5,
  },
  {
    label: "10 Miles",
    value: 10,
  },
  {
    label: "25 Miles",
    value: 25,
  },
  {
    label: "50 Miles",
    value: 50,
  },
  {
    label: "100 Miles",
    value: 100,
  },
];

export const checkValidityForAnonymousToggleEdit = (
  createdDate,
  isAnonymous,
  moduleKey,
  disableAnonimity
) => {
  if (!disableAnonimity[moduleKey]) {
    return false;
  } else {
    if (
      moment(createdDate) <= moment(disableAnonimity[moduleKey]) &&
      isAnonymous
    ) {
      return false;
    } else {
      return true;
    }
  }
};

export const checkValidityForAnonymousToggleCreate = (
  moduleKey,
  disableAnonimity
) => {
  const today = moment();
  if (!disableAnonimity[moduleKey]) {
    return false;
  } else {
    if (today > moment(disableAnonimity[moduleKey])) {
      return true;
    } else {
      return false;
    }
  }
};

export const GENDER_PRONOUNS_MAP = {
  0: "He/him/his",
  1: "She/her/hers",
  2: "They/them/their",
  3: "Ze/hir/hirs, ze/zir/zirs",
};

export const renderGenderPronoun = (user) => {
  // console.log("gpppp",user.genderPronoun)
  if (
    user &&
    user.genderPronoun != null &&
    typeof user.genderPronoun != "undefined" &&
    user.genderPronoun >= 0
  ) {
    return `(${GENDER_PRONOUNS_MAP[user.genderPronoun]})`;
  } else {
    return "";
  }
};

export const GENDER_PRONOUNS_OPTIONS = [
  { label: "He/him/his", value: 0 },
  { label: "She/her/hers", value: 1 },
  { label: "They/them/their", value: 2 },
  { label: "Ze/hir/hirs, ze/zir/zirs", value: 4 },
];

export const resizeImageFromUrl = (url, width, height, callback) => {
  // Create a new image element
  var image = new Image();

  // Set the crossOrigin attribute to handle CORS restrictions (if applicable)
  image.crossOrigin = "Anonymous";

  // When the image is loaded
  image.onload = function() {
    // Create a new canvas element
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    // Set the canvas dimensions to the desired size
    canvas.width = width;
    canvas.height = height;

    // Draw the resized image on the canvas
    ctx.drawImage(image, 0, 0, width, height);

    // Get the resized image as a base64 string
    var resizedImageData = canvas.toDataURL();

    // Pass the resized image data to the callback function
    callback(resizedImageData);
  };

  // Set the source of the image to the URL
  image.src = url;
};

export const removePhraseBetweenCommas = (text, searchString) => {
  if (text) {
    let commaIndex = text.indexOf(",");
    while (commaIndex !== -1) {
      let nextCommaIndex = text.indexOf(",", commaIndex + 1);
      if (nextCommaIndex !== -1) {
        let phrase = text.substring(commaIndex + 1, nextCommaIndex);
        if (phrase.includes(searchString)) {
          let modifiedText = text.replace("," + phrase + ",", ",");
          return modifiedText;
        }
      }
      commaIndex = nextCommaIndex;
    }
    if (text == "undefined") {
      return "";
    } else {
      return text;
    }
  } else {
    return "";
  }
};

export const getEmptyGraphLayoutObject = (margin, fontSize = 28) => {
  return {
    paper_bgcolor: "#e5ecf694",
    plot_bgcolor: "white",
    annotations: [
      {
        text: "No matching data found",
        xref: "paper",
        yref: "paper",
        showarrow: false,
        font: {
          size: fontSize,
        },
      },
    ],
    yaxis: {
      showgrid: false,
    },
    xaxis: {
      showgrid: false,
    },
    margin: margin,
  };
};

export const checkNoDataLayoutValidity = (kpi) => {
  let emptyChartL = 0;

  for (const k of kpi) {
    if (k.x && !k.x.length && k.y && !k.y.length) {
      emptyChartL += 1;
    }
  }

  if (emptyChartL === kpi.length) {
    return true;
  } else {
    return false;
  }
};

export const CUMULATIVE_KPIS = [
  "GRO-1",
  "HRT-1",
  "HRT-2",
  "HRT-4",
  "HRT-5",
  "HRT-6",
  "HRT-7",
];
export const NA_KPIS = [];

export const PERCENT_KPIS = ["COMP-1", "COMP-2", "COMP-3"];

export const deterMineKpiTypeForAveragesTable = (kpiData) => {
  let type = "HISTORICAL";

  for (const kpi of kpiData) {
    if (kpi.kpiId) {
      if (CUMULATIVE_KPIS.includes(kpi.kpiId.code)) {
        type = "CUMULATIVE";
      } else {
        type = "HISTORICAL";
      }
    }
  }
  return type;
};

export const profilePicValidityCheck = (profilePic) => {
  if (
    profilePic &&
    profilePic != null &&
    profilePic != "null" &&
    profilePic != "undefined" &&
    profilePic.length > 0 &&
    profilePic != undefined
  ) {
    return true;
  } else {
    return false;
  }
};

export const INVALID_REDIRECT_PATHNAMES = [
  "/home/undefined",
  "/homeundefined",
  "/undefined",
];

export const NO_CONTENT_MESSAGE =
  "Sorry, it looks like the item or page you were looking for cannot be found";

export const getAvgTenureFormatted = (value) => {
  console.log(value);
  if (value == 0) {
    return "N/A";
  }
  // console.log('value --- ', value)
  // const fixed = parseFloat(value).toFixed(2)
  // const years = Math.floor(fixed);
  const years = Math.round(moment.duration(value, "years").years());
  // const months  = `${Math.round((fixed - years)*12)}`
  const months = Math.round(moment.duration(value, "years").months());
  // console.log("months: ", months)
  // console.log("years: ", years)
  return `${years > 0 ? `${years} yr` : ""}${
    years > 0 && months > 0 ? "," : ""
  } ${months > 0 ? `${months} mo.` : ""}`;

  // return `${years > 0 ?`${years} yr` :""}${years > 0 && months > 0 ?",":""} ${months > 0 ? `${months} mo.` :""}`

};
export const formatQuestionsNumberWise = (questions) => {
  const questionsArr = [...questions];

  const orderedQuestions = questionsArr.map((x, idx) => ({
    ...x,
    order: idx + 1,
  }));

  return orderedQuestions;
};
export const reorderQuestions = (questions) => {
  const shuffle = (array) => {
    let currentIndex = array.length,
      randomIndex;

    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  };
  const questionsArr = [...questions];

  const shuffledQuestions = shuffle(questionsArr);

  return shuffledQuestions;
};

export function convertToRgba(color) {
  // Check if the input is already an RGBA string
  if(color.startsWith("#")){
    color = hexToRgb(color)
  }
  if (color.startsWith("rgba")) {
    return color; // Return as-is
  }

  // Check if the input is an RGB string
  if (color.startsWith("rgb")) {
    // Extract RGB values
    const match = color.match(/\d+/g); // Matches digits
    if (!match || match.length !== 3) {
      throw new Error("Invalid RGB format. Expected 'rgb(r, g, b)'");
    }

    const [r, g, b] = match.map(Number); // Convert to numbers
    return `rgba(${r}, ${g}, ${b}, 1)`; // Add alpha 1
  }

  throw new Error("Invalid color format. Expected 'rgb(r, g, b)' or 'rgba(r, g, b, a)'");
}

export function rgbToHex(rgbString) {
  // Ensure values are within the valid range (0-255)
  if (rgbString.indexOf("rgb") >= 0) {
    if (rgbString) {
      const rgbArr = rgbString
        .replace("rgb(", "")
        .replace(")", "")
        .split(",");

      let [r, g, b] = rgbArr;
      r = Math.min(255, Math.max(0, r));
      g = Math.min(255, Math.max(0, g));
      b = Math.min(255, Math.max(0, b));

      // Convert each component to a hex string and concatenate
      const hexR = r.toString(16).padStart(2, "0");
      const hexG = g.toString(16).padStart(2, "0");
      const hexB = b.toString(16).padStart(2, "0");

      return `#${hexR}${hexG}${hexB}`;
    } else {
      return "#ffffff";
    }
  } else {
    return rgbString;
  }
}

export function hexToRgb(hex) {
  // Remove the hash symbol, if present
  hex = hex.replace(/^#/, "");

  // Parse the hex value to get individual R, G, B components
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgb(${r}, ${g}, ${b})`;
}

export const isUrlValid = (userInput) => {
  var res = userInput.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );
  if (res == null) return false;
  else return true;
};

function unescapeString(input) {
  // Regular expression to detect strings that look like JSON-escaped strings
  const escapedStringPattern = /^"(?:\\.|[^"\\])*"$/;

  if (escapedStringPattern.test(input)) {
      // Remove the surrounding quotes and unescape the content
      return input
          .slice(1, -1) // Remove the leading and trailing quotes
          .replace(/\\n/g, '\n') // Replace escaped newlines
          .replace(/\\"/g, '"') // Replace escaped double quotes
          .replace(/\\\\/g, '\\'); // Replace escaped backslashes
  }

  return input;
}


export const contvertHTMLToPlain = (txt) => {
  try{
    if(typeof txt ==="number"){
      return txt.toString()
    }else{

      if (txt && txt.length) {
        return unescapeString(txt.replace(/<[^>]+>/g, ""));
      } else {
        return "";
      }
    }
  }catch(e){
    return txt
  }


};


export const DANI_SLACK_MEMEBER_MESSAGE =
  "Dani is not added as a member to this channel , Please Add Dani as a member to this channel to Post a message";
export const TRIVVY_SLACK_MEMEBER_MESSAGE =
  "Please configure And add slack bot as a member to this channel to Post a message";

export const TRIVIA_DESCRIPTION =
  "Trivvy is a bite-sized survey generated by AI.";

export const USER_CHATS_EMPTY_STATE_MSG =
  "Looks like there are no chats shared with you.";



export const STRIPE_PUBLIC_KEY = window.location.href.indexOf("trivvy.ouroffice.io")>=0
  ? "pk_live_51OKa9DC7Hc2xQjay6o7cYO8EN06TuG8VJplBk3Wrm2ABPMfs0SndDuh32Tfo9LTkpdLYvR6cURt8MTtWrq1jL9b000GaqK2jaJ"
  : "pk_test_51OKa9DC7Hc2xQjayREu8hvlna1ehR59MeWGuAn0U5BRpGVbTqAV36lOGZYAeQDCGz55cTX39j8RE0HjyX2DG2hvy007Z1zWI5F";

//updated to include docx
export const trivvyFileTypeCheck = (type) => {
  const allowed = [
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "text/plain",
  ];

  return allowed.includes(type);
};

export function generateRandomString(length) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export const manageRoleText = (user) => {
  if (!user) {
    return "User";
  }

  if ((user.role === "Admin" || user.role === "Enterprise Admin") && user.orgAdmin) {
    return "Enterprise Admin";
  }

  if (user.role === "Admin") {
    return "Admin";
  }
  // Fallback
  return "User";
};


export const privacy_options = [
  {label:"Private",value:0},
  {label:"Public",value:1},
  {label:"Linked",value:2},
]

export  function extractAndDecodeFilename(url) {
  // Decode the URL
  const decodedUrl = decodeURIComponent(url);

  // Extract the filename using regex
  const regex = /\/([^\/?#]+)\.[^\/?#]+$/;
  const match = decodedUrl.match(regex);

  if (match) {
    // Get the filename with extension
    const filenameWithExtension = match[1];

    // Replace parentheses with an empty string
    const filename = filenameWithExtension.replace(/[\(\)]/g, '');

    return filename;
  }

  return null;
}

export const stripHtmlTags = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
};


export const REACTION_ID_NAME_MATCH  = {
  "Like":"reaction_like_01",
  "Celebrate":"reaction_celebrate_01",
  "Curious":"reaction_curious_01",
  "Sad":"reaction_sad_01",
  "Support":"reaction_support_01",
  "Thanks":"reaction_thanks_01",
  "Action":"reaction_action_01"
}

// export const removeDuplicatesUsersByEmailAndMobileNumber=(arr) =>{
//   const emails = new Set();
//   const phoneNumbers = new Set();

//   return arr.filter(item => {
//     const { email, mobileNumber } = item;

//     if ( (email && emails.has(email))  || (mobileNumber &&  phoneNumbers.has(mobileNumber))) {
//       return false; // exclude duplicates (either email or phoneNumber is already seen)
//     }

//     if(email){
//       emails.add(email); // add email to the Set
//     }
//     if(mobileNumber){
//       phoneNumbers.add(mobileNumber); // add phoneNumber to the Set
//     }

//     return true; // include unique item
//   });
// }

export function formatPhoneNumber(phoneNumber) {
  // Regular expression to check if the phone number already has a country code
  const countryCode = "+1"
  const countryCodeRegex = /^\+\d+/;

  // Check if the phone number starts with a country code
  if (countryCodeRegex.test(phoneNumber)) {
    return phoneNumber; // Return the phone number as-is
  }
  // If no country code, prepend the default country code
  if(phoneNumber){
    return `${countryCode}${phoneNumber}`;
  }else{
    return "";
  }

}

export const OVERTIME_TEXT = `To avoid overtime risks, please add a note in your Trivvy Subtitle or Description when you are in Edit mode: "Your participation is voluntary. No response is required outside your work hours."`;
export const NOTE='To share a Trivvy with users on this platform, you first need to go to the “Users List” page (on the top right corner of your screen) and upload a file or invite them. Then come back here to share the Trivvy with them. Otherwise, select one of the Other Ways below.'
export const TIP='To avoid overtime risks, please include a statement with your Trivvy. For example: "Your participation is voluntary. No response is required outside your work hours."'

export const TRIVIA_EDIT_OVERTIME_TEXT=`To avoid overtime risk, please include a statement in your trivvy.  For example: “No response is required outside your work hours.`
export const APPLICABLE_USER_FILE_LABEL = "The applicable user file is:";
export const APPLICABLE_USER_FILE_TOOLTIP = "This is the latest user file uploaded prior to publishing this Trivvy. It drives the available filters for sharing and results.";
export const metaData_unique_value_limit = 1000


export const formatPhoneNumberForMetaData = (input, defaultRegion = "US") => {
  const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
  const PNF = libphonenumber.PhoneNumberFormat;

  const inputStr = String(input || "").trim(); // ensure string
  console.log(inputStr, "inputStr");

  try {
    const number = phoneUtil.parseAndKeepRawInput(inputStr, defaultRegion);
    if (phoneUtil.isValidNumber(number)) {
      return phoneUtil.format(number, PNF.E164);
    }
  } catch (err) {
    console.log("Initial parse failed:", inputStr, err);
  }

  try {
    let fallback = inputStr;
    if (!inputStr.startsWith("+")) {
      fallback = `+1${inputStr}`;
    }

    const number = phoneUtil.parseAndKeepRawInput(fallback, defaultRegion);
    if (phoneUtil.isValidNumber(number)) {
      return phoneUtil.format(number, PNF.E164);
    }
  } catch (fallbackErr) {
    console.log("Fallback also failed:", inputStr, fallbackErr);
  }

  return inputStr; // return original string if invalid
};


export const EMPTY_VALUE_LABEL = "--";


export const orgUserMetaDataKeysLimit = 20;

export const TRIVVY_SETTINGS_MODAL_SUBTITLE =
  "Control notifications, scheduling and anonymity for this Trivvy.";

export const TRIVVY_SETTINGS_MODAL_CANCEL_LABEL = "Cancel";

export const NO_HEADING_COLUMN_PLACEHOLDER = "Enter a heading";

export const NO_HEADING_COLUMN_PREFIX = "Column";

export const fieldOptions = [
  { label: "Employee ID", value: "employeeId" },
  { label: "Email", value: "email" },
  { label: "First Name", value: "firstName" },
  { label: "Last Name", value: "lastName" },
  { label: "Mobile Number", value: "mobileNumber" },
];

export const fieldOptionsArray = [ // being used to not show the list of keys that not needed in CSV file import history page
  // "employeeId", we want to controll this 
"email",
"firstName",
"lastName",
"mobileNumber",
]

export function formatCamelCase(label) {
  if (!label) return "";
  return label
    .replace(/([a-z])([A-Z])/g, "$1 $2") // inserts space before capital letters
    .replace(/^./, function(str) {
      return str.toUpperCase();
    })
    .trim();
}

export function mergeAndFormatOptions(allKeyOptions) {
  

  // Create a lookup of values already in allKeyOptions
  var existingValues = {};
  for (var i = 0; i < (allKeyOptions || []).length; i++) {
    var item = allKeyOptions[i];
    if (item && item.value) {
      existingValues[item.value] = true;
    }
  }

  // Filter fieldOptions to include only those not in allKeyOptions
  var additionalOptions = [];
  for (var j = 0; j < (fieldOptions || []).length; j++) {
    var fieldItem = fieldOptions[j];
    if (fieldItem && fieldItem.value && !existingValues[fieldItem.value]) {
      additionalOptions.push(fieldItem);
    }
  }

  // Put new (additional) options at the start
  var combined = (additionalOptions || []).concat(allKeyOptions || []);

  var seen = {};
  var uniqueOptions = [];

  for (var k = 0; k < combined.length; k++) {
    var option = combined[k];
    if (option && option.value && !seen[option.value]) {
      seen[option.value] = true;
      
      uniqueOptions.push({
        ...option,
        label: formatCamelCase(option.label),
        value: option.value,
      });
    }
  }

  return uniqueOptions;
}
